/* eslint-disable no-alert */
import React, { useEffect, useState, useContext } from 'react';
import { useHistory, useLocation, useParams } from 'react-router-dom';
import {
    GetCampaign,
    GetCampaignPropertyStats,
    GetCampaignFromOpportunity,
    GetCampaignStaticData,
    CreateCampaign,
    UpdateCampaign,
    GetCampaignSplitStatistics,
    GetBillingPlanInvoicesByCampaign,
    GetCampaignSpots,
    GetCampaignSettings,
    GetActiveDiscountWorkflowRequest,
    GetActiveValuePotWorkflowRequest,
    QualifyOutCampaign,
    GetCampaignStatuses,
    CancelCampaign,
    AmendCampaign,
    GetCampaignVersion,
    GetCampaignBurst,
    CreateCampaignBurst,
    UpdateCampaignBurst,
    DiscardCampaign,
    GetActiveCancellationWorkflowRequest,
    GetSandPPropertyTypes,
    CreateEmptyPlan,
    GetPropertySelectionsByCampaignId,
    AmendCampaignBurst,
    GetCampaignBurstVersion,
    DiscardCampaignBurst,
    GetCreditDetailsByCampaign,
    GetPropertySelectionHistories,
    DeleteBillingPlanInvoicesByCampaign,
    CreateCampaignLock,
    GetCampaignLock,
    UpdateCampaignLock,
    GetCampaignLockSettings,
    GetPropertyTotals,
    LoadPropertyDealPrice,
    GetOffairType,
    GetDealStationPrices,
    UpdateOffair,
    GetAccountById,
    GetActiveSpotTypeDistributionWorkflowRequest
} from '../services/CampaignsDataService';
import TopBar from '../components/TopBar/TopBar';
import CampaignBrief from '../components/Campaign/CampaignBrief/CampaignBrief';
import CampaignStations from '../components/Campaign/CampaignStations/CampaignStations';
import AutomationSettings from '../components/Campaign/AutomationSettings/AutomationSettings';
import AirtimeSettings from '../components/Campaign/AirtimeSettings/AirtimeSettings';
import AirtimePlanning from '../components/Campaign/AirtimePlanning/AirtimePlanning';
import OffAirCosts from '../components/Campaign/OffAirCosts/OffAirCosts';
import QuoteAndBooking from '../components/Campaign/QuoteAndBooking/QuoteAndBooking';
import TransmissionTimes from '../components/Campaign/TransmissionTimes/TransmissionTimes';
import Billing from '../components/Campaign/Billing/Billing';
import Performance from '../components/Campaign/Performance/Performance';
import ReferenceAndSavePanel from '../components/Campaign/CampaignBrief/ReferenceAndSavePanel';
import { GetNetworks, GetLedgers, GetUser } from '../services/DataService';
import {
    cancelMessageButtonStyle,
    okMessageButtonStyle,
    runningCampaignStyle
} from '../components/Campaign/CampaignStyles';
import { displayStep } from '../components/Campaign/CampaignUtils';
import moment from 'moment';
import { CampaignGoalEnum, BusinessTypes } from '../constants/Enums';
import { RedirectURL } from '../constants/Endpoint';
import BespokeBilling from '../components/Campaign/BespokeBilling/BespokeBilling';
import { GetLocalJourneyBarStepsAirTime } from '../components/TopBar/JourneyBar/LocalJourneyBarStepsAirTime';
import { GetLocalJourneyBarStepsAirTimeBurst } from '../components/TopBar/JourneyBar/LocalJourneyBarStepsAirTimeBurst';
import { GetLocalJourneyBarStepsSnP } from '../components/TopBar/JourneyBar/LocalJourneyBarStepsSnP';
import { GetLocalJourneyBarStepsPackage } from '../components/TopBar/JourneyBar/LocalJourneyBarStepsPackage';
import { GetLocalJourneyBarStepsOffAirs } from '../components/TopBar/JourneyBar/LocalJourneyBarStepsOffAirs';
import PropertySelection from '../components/Campaign/Properties/PropertySelection';
import { getClaimValue, useModal } from '@adserve/adserve-react-components';

import {
    CreateCampaignCancellationRequest,
    CreateCampaignDiscountRequest,
    CreateCampaignSpotTypeDistributionRequest,
    CreateCampaignValuePotRequest,
    GetWorkflowTeams,
    UsingDynamicWorkflow
} from '../services/WorkflowService';
import { AirtimePlanningContext } from '../contexts/AirtimePlanningContext';
import PackageSelection from '../components/Campaign/CampaignPackages/PackageSelection';
import CampaignBurstBrief from '../components/Campaign/CampaignBurstBrief/CampaignBurstBrief';
import { DefaultInputStatus, ErrorInputStatus } from '../components/Campaign/CampaignBrief/CampaignBriefUtils';
import { SearchCampaignsByNameStarts } from '../components/Campaign/CampaignBrief/CampaignBriefDataService';
import CancelCampaignModal from '../components/Campaign/CancelCampaignModal';
import { GetOffAirCostForBackend } from '../components/Campaign/OffAirCosts/OffAirCostsUtils';

let isClickedOnEdit = false;
let mounted = false;
let actionEdit = true;
const CampaignPage = () => {
    // State
    const history = useHistory();
    const location = useLocation();
    const query = new URLSearchParams(location.search);
    const params = useParams();
    const { addMessage } = useModal();
    const {
        setJourneyBarSteps,
        propertyStats,
        setPropertyStats,
        propertyTotals,
        setPropertyTotals,
        setCurrentPlan,
        planIsInvalid,
        setPlanIsInvalid,
        showInvalidatePlanMessage,
        isCampaignCompleted,
        setIsCampaignCompleted,
        currentCampaignVersionId,
        setCurrentCampaignVersionId,
        contextDispose,
        disableBackButton,
        setDisableBackButton,
        fetchCampaignPropertyStats
    } = useContext(AirtimePlanningContext);

    const [campaignId] = useState(params.campaignId ?? query.get('campaignId'));
    const [campaignDetail] = useState(query.get('campaignDetail'));
    const [propertySelectionId] = useState(query.get('propertySelectionId'));
    const [selectedPropertyState] = useState(query.get('selectedPropertyState'));
    const [passedPropertyId] = useState(query.get('passedPropertyId'));
    const [propertySaved] = useState(query.get('propertySaved'));
    const [backClick] = useState(query.get('backClick'));
    const [burstId] = useState(query.get('burstId'));
    const [opportunityId] = useState(query.get('opportunityId'));
    const externalReadOnly = query.get('readOnly'); // Handle specific readOnly scenarios e.g. Create New in CRM
    const externalIsBooked = query.get('isBooked');
    const [isBurst, setIsBurst] = useState(
        (query.get('businessType') ?? location?.state?.businessType) === BusinessTypes.AIRTIMEBURST.name
    );
    const goBack = query.get('goBack');
    const closeTab = query.get('closeTab');
    const [goBackUrl, setGoBackUrl] = useState(null);
    const isEditable = query.get('isEditable') === null || query.get('isEditable') === 'true';
    const [source] = useState(query.get('source'));
    const [businessType] = useState(query.get('businessType') ?? location?.state?.businessType);
    const [isShowingCancelModal, setIsShowingCancelModal] = useState(false);
    const [cancelUserPAT, setCancelUserPAT] = useState();
    const [workflowTeams, setWorkflowTeams] = useState([]);

    const [currentStep, setCurrentStep] = useState(0);
    const [campaign, setCampaign] = useState({});
    const [campaignBurst, setCampaignBurst] = useState({});
    const [staticData, setStaticData] = useState({});
    const [refreshProperties, setRefreshProperties] = useState(false);

    const [networks, setNetworks] = useState([]);

    const [validCampaignName, setValidCampaignName] = useState(true);
    const [validBurstName, setValidBurstName] = useState(true);
    const [validCampaignGoal, setValidCampaignGoal] = useState(true);
    const [validDeal, setValidDeal] = useState(true);
    const [validCategory, setValidCategory] = useState(true);
    const [validJcn, setValidJcn] = useState(true);
    const [validValuePotJcn, setValidValuePotJcn] = useState(true);
    const [validationInput, setValidationInput] = useState(true);

    const [errorValidationCategory, setErrorValidationCategory] = useState('');
    const [errorValidationProperty, setErrorValidationProperty] = useState('');
    const [errorValidationCampaignGoal, setErrorValidationCampaignGoal] = useState('');
    const [errorValidationAccount, setErrorValidationAccount] = useState('');
    const [errorValidationDates, setErrorValidationDates] = useState('');

    const [journeyBarLoader, setJourneyBarLoader] = useState(true);

    const [pendingBespokeInvoices, setPendingBespokeInvoices] = useState([]);
    const [readOnly, setReadOnly] = useState(false);
    const [cancelledReadOnly, setCancelledReadOnly] = useState(false);
    const [bookedReadOnly, setBookedReadOnly] = useState(false);
    const [ledgers, setLedgers] = useState();
    const [discountApprovalWorkflowId, setDiscountApprovalWorkflowId] = useState();
    const [valuePotApprovalWorkflowId, setValuePotApprovalWorkflowId] = useState();
    const [spotTypeDistributionWorkflowId, setSpotTypeDistributionWorkflowId] = useState();
    const [cancellationApprovalWorkflowId, setCancellationApprovalWorkflowId] = useState();
    const [activeRequest, setActiveRequest] = useState({});
    const [discountRequest, setDiscountRequest] = useState({});
    const [activeValuePotRequest, setActiveValuePotRequest] = useState({});
    const [spotTypeDistributionRequest, setSpotTypeDistributionRequest] = useState({});
    const [activeCancellationRequest, setActiveCancellationRequest] = useState({});
    const [campaignStatuses, setCampaignStatuses] = useState([]);
    const [pageBackSource, setPageBackSource] = useState('');
    const [billingAccountId, setBillingAccountId] = useState();
    const [billingAccountCreditDetails, setBillingAccountCreditDetails] = useState({});
    const [campaignStartDate, setCampaignStartDate] = useState();
    const [campaignEndDate, setCampaignEndDate] = useState();
    const [currentCampaignName, setCurrentCampaignName] = useState();
    const [campaignVersions, setCampaignVersions] = useState([]);
    const [campaignBurstVersions, setCampaignBurstVersions] = useState([]);
    const [currentBurstVersionId, setCurrentBurstVersionId] = useState();
    const [readOnlyProperty, setReadOnlyProperty] = useState(false);
    const [burstReadOnly, setBurstReadOnly] = useState(false);
    const [campaignNameStatus, setCampaignNameStatus] = useState(() => DefaultInputStatus());
    const [campaignBurstNameStatus, setCampaignBurstNameStatus] = useState(() => DefaultInputStatus());
    const [returnPropsAvailable, setReturnPropsAvailable] = useState(false);
    const [propertyTypes, setPropertyTypes] = useState([]);
    const [currentDeal, setCurrentDeal] = useState({});
    const [selectedGoal, setSelectedGoal] = useState(campaign.campaignGoal?.find((x) => x.selected));
    const [contactRoles, setContactRoles] = useState([]);
    const minLengthToStartSearch = 3;
    const [time, setTime] = useState(0);
    const [timerInterval, setTimerInterval] = useState(1000);
    const [campaignLock, setCampaignLock] = useState({});
    const [startCampaignLockInterval, setStartCampaignLockInterval] = useState(0);
    const [campaignLockSettings, setCampaignLockSettings] = useState({});
    const [revenueTypes, setRevenueTypes] = useState([]);
    const [campaignStages, setCampaignStages] = useState([]);
    const [forecastCategories, setForecastCategories] = useState([]);
    const [campaignSaving, setCampaignSaving] = useState(false);
    const [discountChanged, setDiscountChanged] = useState(false);
    const [dealDiscounts, setDealDiscounts] = useState([]);
    const [dealStationPrices, setDealStationPrices] = useState({});

    const isMyCampaignLock = () => {
        return (
            campaign?.id !== undefined &&
            campaign?.id !== window.emptyGuid &&
            campaignLock?.campaignId === campaign?.id &&
            campaignLock?.isReleasedLock === false &&
            !campaignLock?.lockedByDiffUser
        );
    };
    useEffect(() => {
        const timer = setInterval(() => {
            setTime((time) => {
                if (time === 0) {
                    clearInterval(timer);
                    if (isMyCampaignLock()) {
                        clearTimer();
                        makeReadOnly();
                        addMessage({
                            title: 'Session Timeout',
                            message: `${window.translate('You are being timed out due to inactivity')}`,
                            buttons: [{ text: window.translate('Ok') }]
                        });
                    }
                    return 0;
                } else {
                    if (time % campaignLockSettings?.lockKeepAlive === 0 && isMyCampaignLock()) {
                        updateCampaignLock(campaign, false);
                    }
                    return time - 1;
                }
            });
        }, timerInterval);
    }, [startCampaignLockInterval]);

    const makeReadOnly = () => {
        isClickedOnEdit = false;
        setReadOnly(true);
        if (businessType !== BusinessTypes.AIRTIMEBURST.name) {
            if (campaign?.campaignStatusName === 'Booked' || campaign?.campaignStatusName === 'Running') {
                setBookedReadOnly(true);
            } else {
                setCancelledReadOnly(
                    campaign?.campaignStatusName === 'Cancelled' || campaign?.campaignStatusName === 'Completed'
                );
            }
        } else {
            if (campaignBurst?.campaignStatusName === 'Booked' || campaignBurst?.campaignStatusName === 'Running') {
                setBookedReadOnly(true);
            }
            if (
                campaignBurst?.campaignStatusName !== 'Booked' &&
                campaignBurst?.campaignStatusName !== 'Running' &&
                campaignBurst?.campaignStatusName !== 'Expired' &&
                campaignBurst?.campaignStatusName !== 'Completed'
            ) {
                setBurstReadOnly(true);
            }
        }
    };

    const clearTimer = () => {
        setTime(0);
        window.removeEventListener('mousemove', resetTimer);
        window.removeEventListener('keyup', resetTimer);
    };

    const resetTimer = () => {
        setTime(campaignLockSettings?.lockTimeOut);
    };

    const startCampaignLockTimer = () => {
        window.addEventListener('mousemove', resetTimer);
        window.addEventListener('keyup', resetTimer);
        setTime(campaignLockSettings?.lockTimeOut);
        setStartCampaignLockInterval(startCampaignLockInterval + 1);
    };

    const startCampaignLock = (cId) => {
        CreateCampaignLock(cId)
            .then((data) => {
                setCampaignLock(data);
                startCampaignLockTimer();
            })
            .catch((error) => {
                console.log(error);
            });
    };

    useEffect(() => {
        if (campaign?.id) {
            if (campaign?.businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()) {
                setDisableBackButton(true);
                try {
                    fetchCampaignPropertyStats(campaign?.id)
                        .then((data) => {
                            setPropertyStats(data?.propertiesStats);
                            setPropertyTotals(data);
                            setDisableBackButton(false);
                        })
                        .catch((e) => setDisableBackButton(false));
                } catch (e) {
                    setDisableBackButton(false);
                }
            } else {
                setDisableBackButton(false);
            }
        }
    }, [campaign?.id]);

    useEffect(() => {
        // Check campaign is locked
        if (Object.keys(campaignLockSettings).length) {
            if (!campaignLockSettings?.disableCampaignLocking) {
                if (
                    (externalReadOnly === 'false' && campaign?.id !== window.emptyGuid && actionEdit) ||
                    (location?.state?.isEditClick && actionEdit)
                ) {
                    handleCampaignLock(campaignLock, campaign);
                }
            }
        }
    }, [campaignLock?.id, campaignLockSettings, isClickedOnEdit, campaign?.id]);

    const changeMade = (key, value, isUserInput = true) => {
        setCampaign((prevState) => {
            return {
                ...prevState,
                [key]: value,
                ...(isUserInput && { modified: true })
            };
        });
    };

    /*
    const loadData = async (data) => {
        if ((!propertySaved === 'false' && typeof propertySaved !== 'object') || typeof propertySaved === 'object') {
            try {
                const propertyValue = await GetSandPPropertyById(data?.sandPPropertyId, data?.propertyParentId)
                    .then((result) => {
                        const cost = {};
                        const fromDate = {};
                        const toDate = {};
                        const week = {};
                        const spots = {};
                        const episode = {};
                        const impacts = {};
                        const price = {};

                        let defaultSpots = 0;
                        let defaultImpacts = 0;
                        let defaultEpisodeCount = 0;
                        let defaultPropertyListPrice = 0;
                        result.propertySelectionId = data?.id;
                        result.sandPPropertyId = JSON.parse(JSON.stringify(result.id));
                        result.id = JSON.parse(JSON.stringify(data?.id));
                        if (data?.sandPPropertyTypeName !== 'Ongoing') {
                            cost.sandPBudget = data?.sandPBudget;
                            fromDate.startDate = new Date(data?.startDate);
                            toDate.endDate = new Date(data?.endDate);
                            week.weeks = data?.weeks;
                            spots.spotCount = data?.spotCount;
                            episode.episodeCount = data?.episodeCount;
                            impacts.propertyImpacts = data?.propertyImpacts;
                            price.propertyListPrice = data?.propertyListPrice;
                            defaultSpots = result.spotCount;
                            defaultImpacts = result.propertyImpacts;
                            defaultEpisodeCount = result.episodeCount;
                            defaultPropertyListPrice = result.propertyListPrice;
                        } else {
                            cost.sandPBudget = data?.sandPBudget;
                            fromDate.startDate = moment(data?.startDate).format(dateFormat);
                            toDate.endDate = moment(data?.endDate).format(dateFormat);
                            week.weeks = data?.weeks;
                            spots.spotCount = data?.spotCount;
                            episode.episodeCount = data?.episodeCount;
                            impacts.propertyImpacts = data?.propertyImpacts;
                            price.propertyListPrice = data?.propertyListPrice;

                            defaultSpots = result.spotCount;
                            defaultImpacts = result.propertyImpacts;
                            defaultEpisodeCount = result.episodeCount;
                            defaultPropertyListPrice = result.propertyListPrice;
                        }

                        if (data?.isModified) {
                            result.definition = data.definition;
                            const dataMergeObj = { ...data };
                            delete dataMergeObj.id;
                            defaultPropertyListPrice = data?.propertyListPrice;
                            price.propertyListPrice = data?.propertyListPrice;
                            (result.catalogSponsorSpotCount = result?.sponsorSpotCount),
                                (result.catalogAirtimeSpotCount = result?.airtimeSpotCount),
                                (result.catalogPromoSpotCount = result?.promoSpotCount),
                                (result.catalogFeatureSpotCount = result?.featureSpotCount),
                                (result.catalogAdvertorialSpotCount = result?.advertorialSpotCount),
                                (result.catalogLiveReadSpotCount = result?.liveReadSpotCount),
                                (result.catalogSponsorImpacts = result?.sponsorImpacts),
                                (result.catalogAirtimeImpacts = result?.airtimeImpacts),
                                (result.catalogPromoImpacts = result?.promoImpacts),
                                (result.catalogFeatureImpacts = result?.featureImpacts),
                                (result.catalogAdvertorialImpacts = result?.advertorialImpacts),
                                (result.catalogLiveReadImpacts = result?.liveReadImpacts),
                                (result.catalogTotalImpacts = result?.totalImpacts),
                                (result.catalogTotalCost = result?.totalCost),
                                (result.catalogOffAirCosts = result?.offAirCosts),
                                (result.catalogSpotCount = result?.spotCount),
                                (result = { ...result, ...dataMergeObj });
                        }

                        const usedPropertyType = propertyTypes?.find((pt) => result?.sandPPropertyTypeId === pt?.id);
                        result.sandPPropertyType = usedPropertyType;

                        result = {
                            ...result,
                            ...cost,
                            ...fromDate,
                            ...toDate,
                            ...week,
                            ...spots,
                            ...impacts,
                            ...episode,
                            ...price,
                            defaultSpots,
                            defaultImpacts,
                            defaultEpisodeCount,
                            defaultPropertyListPrice
                        };
                        return result;
                    })
                    .catch((error) => {
                        console.log(error);
                        return 'invalid';
                    });
                const usedPropertyType = propertyTypes?.find((pt) => propertyValue?.sandPPropertyTypeId === pt?.id);
                propertyValue.sandPPropertyType = usedPropertyType;
                return propertyValue;
            } catch (e) {
                const usedPropertyType = propertyTypes?.find((pt) => data?.sandPPropertyTypeId === pt?.id);
                data.sandPPropertyType = usedPropertyType;
                return data;
            }
        } else {
            const usedPropertyType = propertyTypes?.find((pt) => data?.sandPPropertyTypeId === pt?.id);
            data.sandPPropertyType = usedPropertyType;
            return data;
        }
    };
    */
    const recalcTotals = async (properties) => {
        if (!properties) properties = propertyStats;

        const propertyIds = [];
        properties?.forEach((sp) => {
            propertyIds.push(sp.id === window.emptyGuid ? sp.sandPPropertyId : sp.id);
        });
    };
    const loadPropertyData = async (id) => {
        return false;
        /*        if (id !== null && id !== undefined && campaign?.dealVersionId) {
            setDisableBackButton(true);
            if (currentCampaignVersionId === window.emptyGuid) {
                GetPropertySelectionsByCampaignId(id)
                    .then(async (result) => {
                        const allProperties = [];
                        for (const property of result) {
                            var weekNo;
                            const startDate = new Date(property?.startDate);
                            const endDate = new Date(property?.endDate);
                            const diffInMs = new Date(endDate) - new Date(startDate);
                            weekNo = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 7)) + 1;
                            property.defaultSandPBudget = property?.sandPBudget / weekNo;
                            property.defaultImpacts = property?.totalImpacts / weekNo;
                            property.defaultPropertyListPrice = property?.propertyListPrice / weekNo;
                            property.defaultSpots = property?.spotCount / weekNo;
                            property.sandPBudget = property.sandPBudget?.toFixed(2);

                            allProperties.push(property);
                        }
                        const propertyIds = [];
                        allProperties?.forEach((sp) => {
                            propertyIds.push(sp.id === window.emptyGuid ? sp.sandPPropertyId : sp.id);
                        });

                        try {
                            const stats = await LoadPropertyDealPrice(propertyIds, campaign);
                            stats?.forEach((s, i) => {
                                const newSelectedProperty = { ...allProperties[i] };
                                if (newSelectedProperty) {
                                    newSelectedProperty.propertyDealPrice = s?.dealPrice;
                                    if (!newSelectedProperty?.hasOwnProperty('previousDealPrice')) {
                                        newSelectedProperty.previousDealPrice = s?.dealPrice;
                                    }
                                }
                                allProperties[i] = newSelectedProperty;
                            });
                        } catch (e) {
                            console.log('Failed to get Deal Prices ', e);
                        }

                        setSelectedProperties(allProperties);
                        recalcTotals(allProperties);
                        setDisableBackButton(false);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            } else {
                GetPropertySelectionHistories(id, currentCampaignVersionId)
                    .then(async (result) => {
                        const allProperties = [];
                        for (const property of result) {
                            property.startDate = new Date(property?.startDate);
                            if (property?.startDate?.getHours() === 23) {
                                property?.startDate?.setTime(property?.startDate?.getTime() + 1 * 60 * 60 * 1000);
                            }
                            property.endDate = new Date(property?.endDate);
                            if (property?.endDate?.getHours() === 23) {
                                property?.endDate?.setTime(property?.endDate?.getTime() + 1 * 60 * 60 * 1000);
                            }
                            var weekNo;
                            const startDate = new Date(property?.startDate);
                            const endDate = new Date(property?.endDate);
                            const diffInMs = new Date(endDate) - new Date(startDate);
                            weekNo = Math.floor(diffInMs / (1000 * 60 * 60 * 24 * 7)) + 1;
                            property.defaultSandPBudget = property?.sandPBudget / weekNo;
                            property.defaultImpacts = property?.totalImpacts / weekNo;
                            property.defaultPropertyListPrice = property?.propertyListPrice / weekNo;
                            property.defaultSpots = property?.spotCount / weekNo;
                            // const propertyValue = await loadData(property);
                            // if (propertyValue !== 'invalid') {
                            allProperties.push(property);
                            // }
                        }
                        const propertyIds = [];
                        allProperties?.forEach((sp) => {
                            propertyIds.push(sp.id === window.emptyGuid ? sp.sandPPropertyId : sp.id);
                        });
                        const stats = await LoadPropertyDealPrice(propertyIds, campaign);
                        stats?.forEach((s, i) => {
                            const newSelectedProperty = { ...allProperties[i] };
                            if (newSelectedProperty) {
                                newSelectedProperty.propertyDealPrice = s?.dealPrice;
                                if (!newSelectedProperty?.hasOwnProperty('previousDealPrice')) {
                                    newSelectedProperty.previousDealPrice = s?.dealPrice;
                                }
                            }
                            allProperties[i] = newSelectedProperty;
                        });
                        setSelectedProperties(allProperties);
                        recalcTotals(allProperties);
                        setDisableBackButton(false);
                    })
                    .catch((error) => {
                        console.log(error);
                    });
            }
        }
        */
    };

    const recalculateOffAirs = async () => {
        const today = moment().toDate();
        const rateData = await GetAccountById(billingAccountId);
        const campaignComission = !campaign.barterAgencyAccountId
            ? campaign.commissionRate
            : campaign.barterCommissionRate;
        const finalCommission =
            campaignComission === rateData.commissionRate ? rateData.commissionRate : campaignComission;
        if (Array.isArray(campaign?.offairActivities)) {
            if (campaign?.offairActivities?.length > 0) {
                campaign?.offairActivities?.forEach(async (coa) => {
                    const offAirs = await GetOffAirCostForBackend(coa);
                    GetOffairType(coa.offairTypeId).then((offairType) => {
                        // const billingDate = moment(offAirs[0].billingDate).toDate();
                        if (offairType.defaultCommission === true) {
                            offAirs[0].commission = finalCommission;
                        }
                        for (const data of offAirs) {
                            UpdateOffair(data).then((res) => {});
                        }
                    });
                });
            }
        }
    };

    useEffect(() => {
        GetDealStationPrices().then((data) => {
            const updatedDealStationPrices = {};
            data?.data?.forEach((d, i) => {
                updatedDealStationPrices[d?.stationId] = d;
            });
            setDealStationPrices(updatedDealStationPrices);
        });
        if (campaign?.id) {
            loadPropertyData(campaign?.id);
        }
    }, [campaign?.id, campaign?.dealVersionId]);

    useEffect(() => {
        if (campaign?.id && billingAccountId && billingAccountId !== window.emptyGuid) {
            GetCreditDetailsByCampaign(campaign?.id, billingAccountId)
                .then((result) => {
                    setBillingAccountCreditDetails(result);
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [campaign?.id, billingAccountId]);

    const handleAutomationSettingsChange = (key, value, isUserInput = true) => {
        changeMade(key, value, isUserInput);

        showInvalidatePlanMessage(null, false);
    };
    const handleRationaleChange = (key, value, isUserInput = true) => {
        changeMade(key, value, isUserInput);
    };
    useEffect(() => {
        // Check campaign is locked
        if (
            location?.state?.isEditClick !== undefined ||
            externalReadOnly === 'false' ||
            location?.state?.readOnly !== undefined
        ) {
            if (location?.state?.isEditClick || externalReadOnly === 'false' || !location?.state?.readOnly) {
                isClickedOnEdit = true;
                actionEdit = true;
            }
        }
    }, [location?.state?.isEditClick, externalReadOnly, location?.state?.readOnly]);

    const formatLaydown = (propIn) => {
        const newProp = {};
        newProp.stations = [];
        const spotTypeLookup = {};

        if (propIn?.hasOwnProperty('stations')) {
            let stationsToEnumerate = propIn.stations;
            const statsResultStation = '-1';

            if (statsResultStation !== '-1' && statsResultStation !== -1) {
                stationsToEnumerate = {};
                const stationToUse = propIn?.stations[statsResultStation];
                stationsToEnumerate[statsResultStation] = stationToUse;
            }

            for (const prop in stationsToEnumerate) {
                if (prop == -1) continue;
                if (prop == undefined || prop === 'undefined') continue;
                const oldSt = propIn?.stations[prop];
                const weeksToEnumerate = Object.keys(oldSt?.weeks);

                const newSt = { ...dealStationPrices[prop] };
                newSt.id = prop;

                newSt.weeks = [];
                weeksToEnumerate?.forEach((propWk, i) => {
                    const oldWk = oldSt?.weeks[propWk];

                    const newWk = {
                        sponsorCredits: oldWk?.sponsorCredits
                            ? oldWk.sponsorCredits?.length > 0
                                ? oldWk?.sponsorCredits
                                : []
                            : [],
                        promoTrails: [],
                        features: oldWk?.features ? (oldWk.features?.length > 0 ? oldWk?.features : []) : [],

                        scheduledContent: oldWk?.scheduledContent
                            ? oldWk.scheduledContent?.length > 0
                                ? oldWk?.scheduledContent
                                : []
                            : [],
                        advertorials: oldWk?.advertorials
                            ? oldWk.advertorials?.length > 0
                                ? oldWk?.advertorials
                                : []
                            : [],
                        liveReads: oldWk?.liveReads ? (oldWk.liveReads?.length > 0 ? oldWk?.liveReads : []) : [],
                        partnerAirtimes: oldWk?.partnerAirtimes
                            ? oldWk.partnerAirtimes?.length > 0
                                ? oldWk?.partnerAirtimes
                                : []
                            : []
                    };

                    newSt.weeks.push(newWk);
                });

                newProp.stations.push(newSt);
            }
        }
        newProp.spotTypeLookup = spotTypeLookup;
        return newProp;
    };

    const doClose = async () => {
        isClickedOnEdit = false;
        if (!campaignLockSettings?.disableCampaignLocking) {
            if (!location?.state?.readOnly || !readOnly || !bookedReadOnly) {
                if (campaign?.id !== undefined && campaign?.id !== window.emptyGuid) {
                    if (campaignLock) {
                        if (campaignLock?.campaignId === campaign?.id && !campaignLock?.lockedByDiffUser) {
                            updateCampaignLock(campaign, true);
                        }
                    }
                }
                setCampaignLock({});
                clearTimer();
            }
        }

        if (businessType === BusinessTypes.AIRTIMEBURST.name || closeTab) {
            window.close();
        }

        if (goBackUrl) {
            window.open(goBackUrl, '_self');
        } else if (goBack) {
            history.goBack();
        } else {
            history.push({
                pathname: '/',
                state: { tabId: 0 }
            });
        }
    };

    const handleClose = async () => {
        if (pageBackSource) {
            window.open(RedirectURL(pageBackSource), '_self');
        }

        if (campaignBurst?.id) {
            if (campaignBurst?.modified !== true) {
                doClose();
                return;
            }
        } else {
            if (campaign?.modified !== true) {
                doClose();
                return;
            }
        }

        addMessage({
            message: window.translate('Do you wish to save your changes?'),
            buttons: [
                {
                    text: 'No',
                    style: { ...cancelMessageButtonStyle, width: 132 },
                    callback: () => doClose()
                },
                {
                    text: 'Yes',
                    style: okMessageButtonStyle,
                    callback: async () => {
                        let result;

                        if (campaignBurst?.id) {
                            if (campaignBurst.id === window.emptyGuid) {
                                handleCreateCampaignBurst(true).then((response) => {
                                    if (response) {
                                        doClose();
                                    }
                                });
                            } else {
                                handleUpdateCampaignBurst(true, true).then((response) => {
                                    if (response) {
                                        doClose();
                                    }
                                });
                            }
                        } else {
                            if (campaign.id === window.emptyGuid) {
                                result = await handleCreate();
                            } else {
                                result = await handleUpdate();
                            }
                            if (result) {
                                doClose();
                            }
                        }
                    }
                }
            ]
        });
    };

    const getCampaignBillingPlanInvoices = async (id) => {
        GetBillingPlanInvoicesByCampaign(id).then((res) => {
            changeMade('invoices', res?.data, false);
        });
    };

    const campaignHasSpots = async (id) => {
        GetCampaignSpots(id).then((res) => {
            if (res?.data?.length) {
                changeMade('hasSpots', true, false);
            }
        });
    };

    useEffect(() => {
        if (currentCampaignVersionId === window.emptyGuid && campaign?.campaignVersionId !== undefined) {
            getCampaign(campaign.id).then(() => {
                // loadPropertyData(campaign.id);
            });
        } else {
            if (campaignBurst?.id) {
                if (currentBurstVersionId === window.emptyGuid) {
                    getCampaignBurst(campaignBurst.id);
                } else {
                    getCampaignBurstVersion();
                }
            } else {
                getCampaignVersion().then(() => {
                    //  loadPropertyData(campaign.id);
                });
            }
        }
    }, [currentCampaignVersionId, currentBurstVersionId]);

    useEffect(() => {
        if (planIsInvalid) {
            changeMade('currentPlan', undefined, false);
        }
    }, [planIsInvalid]);

    const getCampaignVersion = async () => {
        if (currentCampaignVersionId !== window.emptyGuid) {
            GetCampaignVersion(currentCampaignVersionId)
                .then((data) => {
                    data.committedSpend = data.budget;
                    data.modified = false;
                    if (data.dayWeights && data.applicableDayParts) {
                        data.distributionStationsChanged = false;
                    }
                    setCampaign(data);
                    setBillingAccountId(data.billingAccountId);
                    setCampaignStartDate(data.startDate);
                    setCampaignEndDate(data.endDate);
                    setCurrentCampaignName(data.name);
                    setReadOnly(true);
                    setBookedReadOnly(true);
                })
                .catch((e) => console.log(e));
        }
    };

    const getCampaignBurstVersion = async () => {
        if (currentBurstVersionId !== window.emptyGuid) {
            const data = await GetCampaignBurstVersion(currentBurstVersionId);

            setCampaignBurst(data);
            // setBillingAccountId(data.billingAccountId);
            setCampaignStartDate(data.startDate);
            setCampaignEndDate(data.endDate);
            setCurrentCampaignName(data.name);
            setReadOnly(true);
            setBurstReadOnly(true);
            setBookedReadOnly(true);
        }
    };

    const getCampaign = async (campId, locationReadOnly = undefined) => {
        if (campId) {
            GetCampaign(campId, businessType)
                .then((data) => {
                    data.committedSpend = data.budget;
                    if (data.id === window.emptyGuid) {
                        const adserveCampaignAccount = localStorage.getItem('AdserveCampaignAccount');
                        if (adserveCampaignAccount) {
                            localStorage.removeItem('AdserveCampaignAccount');
                            const campaignAccount = JSON.parse(adserveCampaignAccount);
                            data.advertiserAccountId = campaignAccount.advertiserAccountId;
                            data.agencyAccountId = campaignAccount.agencyAccountId;
                            data.advertiserAccountName = campaignAccount.advertiserAccountName;
                            data.agencyAccountName = campaignAccount.agencyAccountName;
                            data.productCategoryId = campaignAccount.productCategoryId;
                            data.productCategoryName = campaignAccount.productCategoryName;
                            data.commissionRate = campaignAccount.commissionRate;
                            data.billingAccountId =
                                campaignAccount.agencyAccountId !== undefined
                                    ? campaignAccount.agencyAccountId
                                    : campaignAccount.advertiserAccountId;
                            data.billingAccountName =
                                campaignAccount.agencyAccountId !== undefined
                                    ? campaignAccount.agencyAccountName
                                    : campaignAccount.advertiserAccountName;
                            setGoBackUrl(campaignAccount.goBackUrl);
                        }
                        setPlanIsInvalid(true);
                    }

                    if (businessType === BusinessTypes.AIRTIMEBURST.name) {
                        data.businessType = BusinessTypes.AIRTIMEBURST.name;
                        data.noUpdateGoal = true;
                    }

                    data.modified = false;

                    if (data.dayWeights && data.applicableDayParts) {
                        data.distributionStationsChanged = false;
                    }

                    let campData = data;
                    let needsRefreshProperties = true;
                    if (typeof campaignDetail === 'string') {
                        const parsedCampaignDetail = JSON.parse(campaignDetail);
                        if (parsedCampaignDetail?.id === '00000000-0000-0000-0000-000000000000') {
                            campData = { ...campData, ...parsedCampaignDetail };
                            needsRefreshProperties = true;
                        }
                    }
                    setCampaign(campData);
                    if (needsRefreshProperties) {
                        setRefreshProperties(true);
                    }
                    setBillingAccountId(data.billingAccountId);
                    setCampaignStartDate(data.startDate);
                    setCampaignEndDate(data.endDate);
                    setCurrentCampaignName(data.name);
                    setCampaignVersions(data.campaignVersions);
                    setCurrentCampaignVersionId(window.emptyGuid);
                    console.log('data', data);
                    setCurrentPlan(data.currentPlan);

                    if (data?.campaignStatusName === 'Booked' || data?.campaignStatusName === 'Running') {
                        setBookedReadOnly(locationReadOnly !== undefined ? locationReadOnly : true);
                        setReadOnly(true);
                    }

                    // if (data?.campaignStatusName === 'Cancelled') {
                    //     setReadOnly(true);
                    // } else
                    if (externalReadOnly !== null) {
                        if (businessType === BusinessTypes.AIRTIMEBURST.name) {
                            setBurstReadOnly(externalReadOnly === 'true');
                        } else {
                            setReadOnly(externalReadOnly === 'true');
                        }
                    }

                    if (typeof externalIsBooked === 'string') {
                        if (externalIsBooked === 'true') {
                            setReadOnly(true);
                        }
                    }

                    if (data?.campaignStatusName === 'Completed') {
                        setIsCampaignCompleted(true);
                    }

                    if (source === 'planning') {
                        setCurrentStep(3);
                    }
                })
                .catch((e) => console.log(e));
            getGoBackUrl();
        } else if (opportunityId) {
            GetCampaignFromOpportunity(opportunityId)
                .then((data) => {
                    data.modified = false;
                    if (data.dayWeights && data.applicableDayParts) {
                        data.distributionStationsChanged = false;
                    }
                    data.businessType = businessType;
                    setCampaign(data);
                    setBillingAccountId(data.billingAccountId);
                    setCampaignStartDate(data.startDate);
                    setCampaignEndDate(data.endDate);
                    setCurrentCampaignName(data.name);
                })
                .catch((e) => {
                    console.log(e, 'ERROR');
                });
            if (externalReadOnly !== null) {
                setReadOnly(externalReadOnly === 'true');
            } else {
                setReadOnly(true);
            }
        }
    };

    const getCampaignBurst = async (burstId, overrideEdit = false) => {
        if (burstId) {
            GetCampaignBurst(burstId, campaignId).then((data) => {
                if (data.campaignId === window.emptyGuid) {
                    data.campaignId = campaignId ?? window.emptyGuid;
                    setPlanIsInvalid(true);
                }
                setCampaignBurstVersions([...data.campaignVersions]);
                setCurrentCampaignVersionId(window.emptyGuid);

                // I'm not sure why this is coming in as a string but it shouldn't be
                if (typeof data?.currentPlan?.reservedUntil === 'string') {
                    data.currentPlan.reservedUntil = new Date(data.currentPlan.reservedUntil);
                }

                setCampaignBurst(data);
                setCurrentPlan(data.currentPlan);

                if (externalReadOnly !== null) {
                    if (
                        data?.campaignStatusName !== 'Booked' &&
                        data?.campaignStatusName !== 'Running' &&
                        data?.campaignStatusName !== 'Expired' &&
                        data?.campaignStatusName !== 'Completed'
                    ) {
                        if (overrideEdit) {
                            setBurstReadOnly(false); // This is because we are amending and it will set to true if we came from readOnly
                        } else {
                            setBurstReadOnly(externalReadOnly === 'true');
                        }
                    }

                    if (data?.campaignStatusName === 'Booked' || data?.campaignStatusName === 'Running') {
                        setBookedReadOnly(externalReadOnly === 'true');
                        setBurstReadOnly(true);
                        setReadOnly(true);
                    }
                }
            });
        }
    };

    const getGoBackUrl = () => {
        const adserveGoBackUrl = localStorage.getItem('AdserveGoBackUrl');
        if (adserveGoBackUrl) {
            localStorage.removeItem('AdserveGoBackUrl');
            setGoBackUrl(adserveGoBackUrl);
        }
    };

    const loadJourneyBarStepsForURL = async () => {
        if (!businessType) {
            return;
        }
        if (businessType === BusinessTypes.AIRTIMEBURST.name) {
            setJourneyBarSteps(GetLocalJourneyBarStepsAirTimeBurst());
        } else {
            try {
                switch (businessType.toLowerCase()) {
                    case BusinessTypes.AIRTIME.name.toLowerCase():
                        setJourneyBarSteps(GetLocalJourneyBarStepsAirTime());
                        break;
                    // PACKAGE business tyoe is not available anymore
                    case BusinessTypes.SANDP.name.toLowerCase():
                        setJourneyBarSteps(GetLocalJourneyBarStepsSnP());
                        break;
                    case BusinessTypes.OFFAIRS.name.toLowerCase():
                        setJourneyBarSteps(GetLocalJourneyBarStepsOffAirs());
                        break;
                    case BusinessTypes.DIGITAL.name.toLowerCase():
                        setJourneyBarSteps(GetLocalJourneyBarStepsOffAirs());
                        break;
                }
            } catch (e) {
                console.log('error', e);
            }
        }
    };

    const loadJourneyBarSteps = async () => {
        if (!campaign?.businessType) {
            return;
        }

        try {
            switch (campaign.businessType.toLowerCase()) {
                case BusinessTypes.AIRTIME.name.toLowerCase():
                    setJourneyBarSteps(GetLocalJourneyBarStepsAirTime());
                    break;
                // case BusinessTypes.AIRTIMEBURST.name.toLowerCase():
                //     setJourneyBarSteps(GetLocalJourneyBarStepsAirTimeBurst());
                //     break;

                // PACKAGE business type removed

                case BusinessTypes.SANDP.name.toLowerCase():
                    setJourneyBarSteps(GetLocalJourneyBarStepsSnP());
                    break;
                case BusinessTypes.OFFAIRS.name.toLowerCase():
                    setJourneyBarSteps(GetLocalJourneyBarStepsOffAirs());
                    break;
                case BusinessTypes.DIGITAL.name.toLowerCase():
                    setJourneyBarSteps(GetLocalJourneyBarStepsOffAirs());
                    break;
            }
        } catch (e) {
            console.log('error', e);
        }
    };

    const getStaticData = async () => {
        const data = await GetCampaignStaticData();
        if (mounted) {
            setRevenueTypes(data.revenueTypes);
            setStaticData(data);
        }
    };
    const getLedgers = async () => {
        const data = await GetLedgers();
        if (mounted) {
            setLedgers(data);
        }
    };
    const getCampaignStatuses = async () => {
        const data = await GetCampaignStatuses();
        if (mounted) {
            setCampaignStatuses(data);
        }
    };
    const getCampaignSettings = async () => {
        const data = await GetCampaignSettings();
        if (mounted) {
            setDiscountApprovalWorkflowId(data.customDiscountsWorkflowId);
            setValuePotApprovalWorkflowId(data.valuePotWorkflowId);
            setSpotTypeDistributionWorkflowId(data.spotTypeDistributionWorkflowId);
            setCancellationApprovalWorkflowId(data.cancelCampaignWorkflowId);
        }
    };

    const getWorkflowTeams = async () => {
        const data = await GetWorkflowTeams();
        if (mounted) {
            setWorkflowTeams(data);
        }
    };

    const loadPropertyTypes = () => {
        GetSandPPropertyTypes().then((res) => {
            setPropertyTypes(res?.data);
        });
    };

    const getCampaignLockSettings = async () => {
        const data = await GetCampaignLockSettings();
        if (mounted) {
            setCampaignLockSettings(data);
            if (!data?.disableCampaignLocking) {
                setTimerInterval(60000);
            }
        }
    };

    useEffect(() => {
        mounted = true;
        const sourceIdx = location?.search?.indexOf('&source=');
        if (sourceIdx !== -1) {
            setPageBackSource(location?.search?.substr(sourceIdx + 8));
        }

        let campId;
        let locationReadOnly = undefined;
        if (location?.state?.campaignId) {
            campId = location?.state?.campaignId;
            setPageBackSource(location?.state?.source);
            setReadOnly(location?.state?.readOnly);
            setBookedReadOnly(location?.state?.readOnly);
            locationReadOnly = location?.state?.readOnly;
        } else if (campaignId) {
            campId = campaignId;
            setReadOnly(true);
            setBookedReadOnly(true);
        }

        getStaticData();
        getCampaign(campId, locationReadOnly);
        getLedgers();
        getCampaignStatuses();
        getCampaignSettings();
        getWorkflowTeams();
        getCampaignLockSettings();
        return () => {
            mounted = false;
            // When returning from Property Manager, don't blitz the properties
            if (typeof selectedPropertyState !== 'string' && typeof propertySelectionId !== 'string') {
                contextDispose();
            }
        };
    }, []);

    const GetDiscountWorkflowRequest = async () => {
        GetActiveDiscountWorkflowRequest(discountApprovalWorkflowId, campaign?.id).then((res) => {
            console.log(':activeDiscount ', res);
            setDiscountRequest(res);
        });
    };

    const GetValuePotWorkflowRequest = async () => {
        GetActiveValuePotWorkflowRequest(valuePotApprovalWorkflowId, campaign?.id).then((res) => {
            setActiveValuePotRequest(res);
        });
    };

    const GetSpotTypeDistributionWorkflowRequest = async () => {
        GetActiveSpotTypeDistributionWorkflowRequest(spotTypeDistributionWorkflowId, campaign?.id).then((res) => {
            setSpotTypeDistributionRequest(res);
        });
    };

    const GetCancellationWorkflowRequest = async () => {
        GetActiveCancellationWorkflowRequest(cancellationApprovalWorkflowId, campaign?.id).then((res) => {
            setActiveCancellationRequest(res);
        });
    };

    const handleCreateCampaignBurst = async (isClosing = false) => {
        setCampaignSaving(true);
        const isInputValid = await IsValidCampaignBurstName();

        if (!isInputValid) {
            window.scrollTo(0, 0);
            setCampaignSaving(false);
            return;
        }

        if (validJcn) {
            const result = await CreateCampaignBurst(campaignBurst);
            campaignBurst.id = result.id;
            campaignBurst.referenceNumber = result.referenceNumber;
            campaignBurst.modified = false;

            if (isClosing) {
                setCampaignSaving(false);
                return true;
            }

            setCampaignSaving(false);
            addMessage({
                message: window.translate('Campaign burst created successfully!'),
                buttons: [
                    {
                        text: window.translate('Ok'),
                        callback: async () => {
                            const data = await GetCampaignBurst(result.id);
                            data.modified = false;
                            const c = await recalcAllocations(data, false, true);
                            setCampaignBurst(c);
                            history.push({
                                pathname: '/campaigns/details',
                                state: {
                                    campaignId: result.id,
                                    businessType: BusinessTypes.AIRTIMEBURST.name,
                                    readOnly: false
                                }
                            });
                        }
                    }
                ]
            });
        }
        setCampaignSaving(false);
    };

    const handleUpdateCampaignBurst = async (showMessage = true, isClosing = false) => {
        setCampaignSaving(true);
        const isInputValid = await IsValidCampaignBurstName();
        if (!isInputValid) {
            window.scrollTo(0, 0);
            setCampaignSaving(false);
            return;
        }
        await UpdateCampaignBurst(campaignBurst);
        getCampaign(campaignBurst.campaignId);
        await recalcAllocations(campaignBurst, false, true);
        setCampaignBurst({ ...campaignBurst, modified: false });
        if (isClosing) {
            setCampaignSaving(false);
            return true;
        }

        if (showMessage) {
            setCampaignSaving(false);
            addMessage({
                message: window.translate('Campaign burst updated successfully!'),
                buttons: [{ text: window.translate('Ok') }]
            });
        }
        setCampaignSaving(false);
    };

    const updateCampaignBurst = (key, value) => {
        setCampaignBurst((prevState) => {
            return {
                ...prevState,
                [key]: value,
                modified: true
            };
        });
    };

    const handleAutomationSettingsBurstChange = (key, value) => {
        updateCampaignBurst(key, value);

        showInvalidatePlanMessage(null, false);
    };

    useEffect(() => {
        if (discountApprovalWorkflowId && campaign?.id) {
            GetDiscountWorkflowRequest();
        }
    }, [discountApprovalWorkflowId, campaign?.id]);

    useEffect(() => {
        if (valuePotApprovalWorkflowId && campaign?.id) {
            GetValuePotWorkflowRequest();
        }
    }, [valuePotApprovalWorkflowId, campaign?.id]);

    useEffect(() => {
        if (spotTypeDistributionWorkflowId && campaign?.id) {
            GetSpotTypeDistributionWorkflowRequest();
        }
    }, [spotTypeDistributionWorkflowId, campaign?.id]);

    useEffect(() => {
        if (cancellationApprovalWorkflowId && campaign?.id) {
            GetCancellationWorkflowRequest();
        }
    }, [cancellationApprovalWorkflowId, campaign?.id]);

    useEffect(() => {
        async function fetchData() {
            await loadJourneyBarSteps();
        }

        if (
            businessType === BusinessTypes.AIRTIMEBURST.name &&
            campaign.businessType &&
            campaign.businessType.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()
        ) {
            // Don't change the journey bar when we load the parent campaign
        } else {
            fetchData();
        }
    }, [campaign.businessType]);

    useEffect(() => {
        async function fetchData() {
            await loadJourneyBarStepsForURL();
        }
        fetchData();
    }, [businessType]);

    useEffect(async () => {
        if (campaign.id) {
            getCampaignBillingPlanInvoices(campaign.id);
            campaignHasSpots(campaign.id);
        }
    }, [campaign.id]);

    useEffect(() => {
        getCampaignBurst(burstId);
    }, [burstId]);

    useEffect(() => {
        if (campaign.ledgerId) {
            GetNetworks(campaign.ledgerId).then((data) => setNetworks(data));
        }
    }, [campaign.ledgerId]);

    const isAirtime = campaign?.businessType?.toLowerCase() === BusinessTypes.AIRTIME.name.toLowerCase();
    const isOffairs =
        campaign?.businessType?.toLowerCase() === BusinessTypes.OFFAIRS.name.toLowerCase() ||
        campaign?.businessType?.toLowerCase() === BusinessTypes.DIGITAL.name.toLowerCase();
    const isSandP = campaign?.businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase();
    // const isPackage = campaign?.businessType?.toLowerCase() === BusinessTypes.PACKAGE.name.toLowerCase();

    const validateBeforeSave = () => {
        setValidationInput(false);
        if (propertyStats?.length) {
            if (propertyStats.some((a) => !a.startDate)) {
                addMessage({
                    message: `${window.translate('Property Selections Must have a start date.')} `,
                    buttons: [{ text: window.translate('OK') }]
                });
                return false;
            }
            if (propertyStats.some((a) => !a.endDate)) {
                addMessage({
                    message: `${window.translate('Property Selections Must have an end date.')} `,
                    buttons: [{ text: window.translate('OK') }]
                });
                return false;
            }
        }
        if (!campaign?.dealVersionId) {
            campaign.dealVersionId = window.emptyGuid;
        }
        if (campaign.valuePotSpend === '') campaign.valuePotSpend = '0';

        const hasProperty = () => {
            return campaign.sandPPropertyId !== '';
        };

        if (
            validCampaignName &&
            ((validCampaignGoal && validDeal && validCategory && validJcn && validValuePotJcn && isAirtime) ||
                (validCategory && isSandP) ||
                isOffairs ||
                (validDeal && validCategory && hasProperty()))
        ) {
            return true;
        } else {
            if (campaign.sandPPropertyId == window.emptyGuid) {
                setErrorValidationProperty(window.translate('Property is required'));
            }

            return false;
        }
    };

    const checkIsValidDeal = () => {
        if (!validDeal && (isAirtime || isSandP)) {
            addMessage({
                message: `${window.translate('Cannot save campaign as no active deals are available')}`,
                buttons: [
                    {
                        text: window.translate('Ok')
                    }
                ]
            });
            return false;
        } else {
            return true;
        }
    };

    const checkIsValidCategory = () => {
        if (!validCategory && (isAirtime || isSandP)) {
            setErrorValidationCategory(window.translate('Category is required'));
            return false;
        } else {
            setErrorValidationCategory(window.translate(''));
            return true;
        }
    };
    const checkIsValidGoal = () => {
        if (!validCampaignGoal && isAirtime) {
            setErrorValidationCampaignGoal(window.translate('Campaign goal is required'));
            return false;
        } else {
            setErrorValidationCampaignGoal(window.translate(''));
            return true;
        }
    };

    const checkIsValidAccount = () => {
        if (!campaign.agencyAccountId && !campaign.advertiserAccountId) {
            setErrorValidationAccount(window.translate('Advertiser or Agency is required'));
            return false;
        } else {
            setErrorValidationAccount(window.translate(''));
            return true;
        }
    };

    const validateName = async (searchValue, validationOnly) => {
        const retValue = true;

        if ((!searchValue || searchValue.length < minLengthToStartSearch) && !validationOnly) {
            setCampaignNameStatus(DefaultInputStatus());
            return retValue;
        }

        if (validationOnly && !searchValue) {
            setCampaignNameStatus(ErrorInputStatus(window.translate('Campaign name is required')));
            return false;
        }

        if (campaign?.id === window.emptyGuid) {
            const results = await SearchCampaignsByNameStarts(searchValue);

            // Remove the current name because we don't want the name matching with itself
            const searchData = results.filter((p) => p.id !== campaignId).map((p) => p.name.trim());

            // We also need to set the status to green if no exact matches found
            if (searchData.findIndex((data) => data.toLowerCase() === searchValue.toLowerCase().trim()) === -1) {
                if (!validationOnly) {
                    setCampaignNameStatus(DefaultInputStatus());
                }
            } else {
                setCampaignNameStatus(ErrorInputStatus('Campaign name already exists'));
            }
        }

        return retValue;
    };

    const validateBurstName = async (searchValue, validationOnly) => {
        const retValue = true;

        if ((!searchValue || searchValue.length < minLengthToStartSearch) && !validationOnly) {
            setCampaignBurstNameStatus(DefaultInputStatus());
            return retValue;
        }

        if (validationOnly && !searchValue) {
            setCampaignBurstNameStatus(ErrorInputStatus(window.translate('Burst name is required')));
            return false;
        }
        return retValue;
    };

    const convertForSave = (propIn, isRefresh = false) => {
        const newProp = {};
        newProp.stations = [];
        const spotTypeLookup = {};

        if (propIn?.hasOwnProperty('stations')) {
            const stationsToEnumerate = propIn.stations;

            for (const prop in stationsToEnumerate) {
                if (prop == -1) continue;
                const oldSt = propIn.stations[prop];

                const newSt = {};
                newSt.id = prop;
                newSt.weeks = [];
                for (const propWk in oldSt.weeks) {
                    const oldWk = oldSt.weeks[propWk];

                    const newWk = {
                        sponsorCredits: [],
                        promoTrails: [],
                        features: oldWk.features
                            ? oldWk.features?.length > 0
                                ? oldWk?.features
                                : isRefresh
                                ? [
                                      {
                                          dayNum: 0,
                                          dayPartId: '0',
                                          value: '0',
                                          spotTypeId: '00000000-0000-0000-0000-000000000000'
                                      }
                                  ]
                                : []
                            : [],
                        advertorials: oldWk.advertorials
                            ? oldWk.advertorials?.length > 0
                                ? oldWk?.advertorials
                                : isRefresh
                                ? [
                                      {
                                          dayNum: 0,
                                          dayPartId: '0',
                                          value: '0',
                                          spotTypeId: '00000000-0000-0000-0000-000000000000'
                                      }
                                  ]
                                : []
                            : [],
                        scheduledContent: oldWk.scheduledContent
                            ? oldWk.scheduledContent?.length > 0
                                ? oldWk?.scheduledContent
                                : isRefresh
                                ? [
                                      {
                                          dayNum: 0,
                                          dayPartId: '0',
                                          value: '0',
                                          spotTypeId: '00000000-0000-0000-0000-000000000000'
                                      }
                                  ]
                                : []
                            : [],
                        liveReads: [],
                        partnerAirtimes: oldWk.partnerAirtimes
                            ? oldWk.partnerAirtimes?.length > 0
                                ? oldWk?.partnerAirtimes
                                : isRefresh
                                ? [
                                      {
                                          dayNum: 0,
                                          dayPartId: '0',
                                          value: '0',
                                          spotTypeId: '00000000-0000-0000-0000-000000000000'
                                      }
                                  ]
                                : []
                            : []
                    };

                    newSt.weeks.push(newWk);
                }

                newProp.stations.push(newSt);
            }
        }
        newProp.spotTypeLookup = spotTypeLookup;
        return newProp;
    };

    useEffect(() => {
        if (typeof campaignDetail === 'string' && campaignId !== '00000000-0000-0000-0000-000000000000') {
            setCampaign(JSON.parse(campaignDetail));
        }
    }, [campaignId, campaignDetail]);

    const IsValidCampaignName = async () => {
        let retVal = true;
        retVal = await validateName(campaign.name, true);

        return retVal;
    };

    const IsValidCampaignBurstName = async () => {
        let retVal = true;
        retVal = await validateBurstName(campaignBurst?.name, true);

        return retVal;
    };

    const isCampaignValid = () => {
        const accountValid = checkIsValidAccount();
        const dealValid = checkIsValidDeal();
        const categoryValid = checkIsValidCategory();
        const goalValid = checkIsValidGoal();

        return accountValid && dealValid && categoryValid && goalValid;
    };

    const handleCreate = async () => {
        if (!campaign?.startDate || !campaign?.endDate) {
            addMessage({
                message: `${window.translate('One or more properties is missing a Start Date and/or End Date')}`,
                buttons: [{ text: window.translate('OK') }]
            });
            return;
        }
        setValidationInput(false);
        setCampaignSaving(true);
        const isInputValid = await IsValidCampaignName();
        let rationaleValid = true;

        if (!isCampaignValid() || !isInputValid) {
            window.scrollTo(0, 0);
            setCampaignSaving(false);
            return;
        }
        if (
            (typeof propertySelectionId === 'string' && propertySaved !== 'false') ||
            propertyStats?.some((sp) => sp?.hasVariance === true)
        ) {
            if (!campaign?.rationale) {
                rationaleValid = false;
            }
        }

        if (validateBeforeSave() && rationaleValid) {
            campaign.modified = false;
            const campaignAttachments = campaign.campaignAttachments || [];
            if (campaign.businessType.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()) {
                campaign.poNumbersJson = {
                    Single: 'SandP',
                    Multiple: [{ DateText: 'Jan 2023', Date: '2023-01-01T00:00:00Z' }],
                    UsingSingle: true
                };
            }
            let result = {};
            let propertiesInvalid = false;
            propertyStats?.forEach((sp, i) => {
                if (!sp?.startDate || !sp?.endDate) {
                    propertiesInvalid = true;
                    addMessage({
                        message: `${window.translate(
                            'One or more properties is missing a Start Date and/or End Date'
                        )}`,
                        buttons: [{ text: window.translate('OK') }]
                    });
                }
            });
            if (propertiesInvalid) {
                campaign.modified = true;
                setCampaignSaving(false);
                return;
            }

            try {
                result = await CreateCampaign(campaign, propertyStats);
                if (campaign?.businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()) {
                    fetchCampaignPropertyStats(result.id).then((data) => {
                        setPropertyStats(data?.propertiesStats);
                        setPropertyTotals(data);
                    });
                }

                if (result.id !== window.emptyGuid) {
                    setCampaignSaving(false);
                    startCampaignLock(result.id);
                }
            } catch (err) {
                setCampaignSaving(false);
                addMessage({
                    message: `${window.translate('An error occurred while attempting to create the campaign.')} ${
                        err.response?.data
                    }`,
                    buttons: [
                        { text: window.translate('Retry'), callback: handleUpdate, useSecondaryStyle: true },
                        { text: window.translate('OK') }
                    ]
                });
            }
            campaign.id = result.id;
            campaign.referenceNumber = result.referenceNumber;
            campaign.campaignStatusName = 'Draft';
            campaign.campaignHistory = result.campaignHistory;
            if (businessType.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()) {
                campaign.refreshPropertyTotals = 1;
            }
            AddAttachmentsAfterCreateCampaign(campaignAttachments, campaign.id);
            setJourneyBarLoader(!journeyBarLoader);
            setErrorValidationCampaignGoal('');
            setErrorValidationCategory('');
            setErrorValidationProperty('');
            loadPropertyData(campaign?.id);
            setCampaignSaving(false);
            addMessage({
                message: window.translate('Campaign created successfully!'),
                buttons: [
                    {
                        text: window.translate('Ok'),
                        callback: async () => {
                            const data = await GetCampaign(result.id);
                            data.modified = false;
                            const c = await recalcAllocations(data, false);
                            setCampaign(c);
                            setBillingAccountId(c.billingAccountId);
                            setCampaignStartDate(c.startDate);
                            setCampaignEndDate(c.endDate);
                            setCurrentCampaignName(c.name);

                            history.push({
                                pathname: '/campaigns/details',
                                state: {
                                    campaignId: result.id,
                                    readOnly: false
                                }
                            });
                        }
                    }
                ]
            });
        } else {
            setCampaignSaving(false);
            window.scrollTo(0, 0);
        }
    };

    const handleUpdate = async () => {
        setValidationInput(false);
        setCampaignSaving(true);
        let rationaleValid = true;
        const isInputValid = await IsValidCampaignName();
        if (!isCampaignValid() || !isInputValid) {
            setCampaignSaving(false);
            addMessage({
                title: 'Validation Errors',
                message: `${window.translate(
                    'There is a problem with the campaign details, please check the brief page'
                )}`,
                buttons: [{ text: window.translate('Ok') }]
            });
            return;
        }
        if (
            (typeof propertySelectionId === 'string' &&
                propertySaved !== 'false' &&
                propertySelectionId !== window.emptyGuid) ||
            propertyStats?.some((sp) => sp?.hasVariance === true)
        ) {
            if (!campaign?.rationale) {
                rationaleValid = false;
                addMessage({
                    message: 'A rationale is required as one or more properties have been edited',
                    buttons: [{ text: window.translate('Ok') }]
                });
            }
        }
        if (validateBeforeSave() && rationaleValid) {
            try {
                if (planIsInvalid) {
                    // Create an empty plan so the user will see this plan when they return rather than the previous version (only applies to reneg campaigns)
                    // Feels icky but don't really have a choice
                    await CreateEmptyPlan(campaign.id);
                }
                propertyStats?.forEach((sp, i) => {});

                await UpdateCampaign(campaign, propertyStats);
                if (campaign?.businessType?.toLowerCase() === BusinessTypes.SANDP.name.toLowerCase()) {
                    const statsResult = await fetchCampaignPropertyStats(campaign.id);
                    setPropertyStats(statsResult?.propertiesStats);
                    setPropertyTotals(statsResult);
                }
                recalculateOffAirs();
                const data = await GetCampaign(campaign.id);
                data.modified = false;
                const c = await recalcAllocations(data, false);
                if (c.dayWeights && c.applicableDayParts) {
                    c.distributionStationsChanged = false;
                }

                if (c?.hasOwnProperty('refreshPropertyTotals')) {
                    c.refreshPropertyTotals += 1;
                } else {
                    c.refreshPropertyTotals = 1;
                }

                setCampaign(c);
                setBillingAccountId(c.billingAccountId);
                setCampaignStartDate(c.startDate);
                setCampaignEndDate(c.endDate);
                setCurrentCampaignName(c.name);
                setJourneyBarLoader(!journeyBarLoader);
                loadPropertyData(campaign?.id);
                setCampaignSaving(false);
                GetBillingPlanInvoicesByCampaign(data?.id).then((res) => {
                    changeMade('invoices', res?.data, false);
                });

                return true;
            } catch (err) {
                setCampaignSaving(false);
                addMessage({
                    message: `${window.translate('An error occurred while attempting to update the campaign.')} ${
                        err.response?.data
                    }`,
                    buttons: [
                        { text: window.translate('Retry'), callback: handleUpdate, useSecondaryStyle: true },
                        { text: window.translate('OK') }
                    ]
                });
                return false;
            }
        } else {
            setCampaignSaving(false);
            window.scrollTo(0, 0);
        }
    };
    const AddAttachmentsAfterCreateCampaign = async (campAttachments, campaignId) => {
        const attachments = campAttachments.filter((n) => !n.id || n.id === window.emptyGuid);
        if (attachments?.length > 0) {
            const AttachmentService = require('../services/AttachmentService');
            let promise;
            try {
                attachments?.forEach((attachment) => {
                    promise = AttachmentService.upload(
                        attachment.file,
                        null,
                        campaignId,
                        attachment.name,
                        attachment.description,
                        'campaign'
                    );
                });
            } catch (err) {
                console.error(err);
            }

            if (await promise) {
                changeMade('hasAttachments', true);
            }
        }
    };

    const handleQualifyOutConfirm = async () => {
        try {
            await QualifyOutCampaign(campaign.id);
            const qualifiedStatus = campaignStatuses?.find((c) => c?.shortCode === 'QO');
            const updatedCampaign = await getCampaign(campaign.id);
            setCampaign((prevState) => {
                return {
                    ...prevState,
                    ...updatedCampaign,
                    campaignStatusName: qualifiedStatus?.name,
                    campaignStatusId: qualifiedStatus?.id
                };
            });
        } catch (error) {
            console.log(error);
        }
    };

    const handleQualifyOutBurstConfirm = async () => {
        try {
            await QualifyOutCampaign(campaign.id, campaignBurst.id);
            await getCampaignBurst(campaignBurst.id);
        } catch (error) {
            console.log(error);
        }
    };

    const recalcAllocations = (c, isUserInput = true, isCampaignBurst = false) => {
        const selectGoal = c?.campaignGoal?.find((g) => g.selected === true);
        if (selectGoal?.value) {
            if (
                selectGoal.goal === CampaignGoalEnum.BASEOTH ||
                selectGoal.goal === CampaignGoalEnum.TARGETOTH ||
                selectGoal.goal === CampaignGoalEnum.OVERALLBASEOTH ||
                selectGoal.goal === CampaignGoalEnum.OVERALLTARGETOTH ||
                selectGoal.goal === CampaignGoalEnum.BASEREACH ||
                selectGoal.goal === CampaignGoalEnum.TARGETREACH
            ) {
                if (isCampaignBurst) recalcBurstOth;
                else recalcOth(c.campaignStations, isUserInput);
            } else {
                if (isCampaignBurst) recalcBurst(c.burstStations, isUserInput);
                else recalc(c.campaignStations, isUserInput);
            }
        }
        return c;
    };

    const handleUpdateWithMessage = async () => {
        recalcAllocations(campaign, false);
        if (await handleUpdate()) {
            addMessage({
                message: window.translate('Campaign updated successfully!'),
                buttons: [{ text: window.translate('Ok') }]
            });
        }
    };

    // ToDo: Below is for campaign stations. Moved from old code to get it to work but needs a refactoring
    const convertToDateString = (date) => {
        if (typeof date === 'string') return date;

        const theMoment = moment.utc(date.toDateString());
        return theMoment.toDate().toISOString();
    };

    const recalc = async (stations, isUserInput = true) => {
        campaign.split = true;
        if (stations.length === 0) {
            changeMade('campaignStations', [], false);
            return;
        }

        if (!campaign.startDate || !campaign.endDate) {
            alert('Please enter start and end dates');
            return;
        }

        const goal = campaign.campaignGoal.find((g) => g.selected === true);
        let budget = goal.value;
        if (goal.goal === CampaignGoalEnum.WEEKLYBUDGET) {
            budget = goal.values?.reduce((a, b) => {
                return a + parseFloat(b.value);
            }, 0);
        }

        // We must check if there is a station that was modified by recalcOth function.
        // If yes, then we have to reset all stations to the default values
        if (stations.findIndex((s) => s.proposed === '-') > -1) {
            stations = stations.map((s) => ({
                id: s.id,
                name: s.name
            }));
        }

        const postObj = {
            startDate: convertToDateString(campaign.startDate),
            endDate: convertToDateString(campaign.endDate),
            dealVersionId: campaign.dealVersionId,
            campaignStations: stations,
            budget: goal?.isBurst ? goal?.burstValue : budget,
            campaignId: campaign.id,
            clientId: campaign.advertiserAccountId
        };

        try {
            const response = await GetCampaignSplitStatistics(postObj);
            const stationStats = response.data.stationStatistics;
            for (const station of stations) {
                const stat = stationStats.find((x) => x.stationId === station.id);
                station.budget = stat.value;
                station.originalBudget = stat.originalValue;
                station.isOverriden = stat.isOverriden;
                station.override = stat.override;
                station.naturalSplit = stat.split;
                station.impactsNaturalSplit = stat.impactSplit;
                station.proposed = stat.proposedPercentage;
                station.sellout = stat.sellOutPercentage;
                station.cpt = stat.cptPrice;
                station.spot = stat.spotPrice;
                station.defaultCosting = stat.defaultCosting;
            }

            setCampaign((prevState) => {
                return {
                    ...prevState,
                    totalAvailableValue: response.data.totalAvailableValue,
                    totalAvailableImpacts: response.data.totalAvailableImpacts,
                    allocatedBudget: response.data.allocatedBudget,
                    unallocatedBudget: response.data.unallocatedBudget,
                    campaignStations: stations,
                    ...(isUserInput && { modified: true })
                };
            });
        } catch (e) {
            console.log('Fail to get campaign split statistics', e);
        }
    };

    const recalcBurst = async (stations, isUserInput = true) => {
        if (stations.length === 0) {
            updateCampaignBurst('burstStations', []);
            return;
        }

        if (!campaignBurst.startDate || !campaignBurst.endDate) {
            alert('Please enter start and end dates');
            return;
        }

        const goal = campaignBurst.campaignGoal.find((g) => g.selected === true);

        // We must check if there is a station that was modified by recalcOth function.
        // If yes, then we have to reset all stations to the default values
        if (stations.findIndex((s) => s.proposed === '-') > -1) {
            stations = stations.map((s) => ({
                id: s.id,
                name: s.name
            }));
        }

        const postObj = {
            startDate: convertToDateString(campaignBurst.startDate),
            endDate: convertToDateString(campaignBurst.endDate),
            dealVersionId: campaign.dealVersionId,
            campaignStations: stations,
            budget: goal?.isBurst ? goal?.burstValue : goal?.value,
            campaignId: campaignBurst.id,
            clientId: campaign.advertiserAccountId
        };

        try {
            const response = await GetCampaignSplitStatistics(postObj);
            const stationStats = response.data.stationStatistics;
            for (const station of stations) {
                const stat = stationStats.find((x) => x.stationId === station.id);
                station.budget = stat.value;
                station.originalBudget = stat.originalValue;
                station.isOverriden = stat.isOverriden;
                station.override = stat.override;
                station.naturalSplit = stat.split;
                station.impactsNaturalSplit = stat.impactSplit;
                station.proposed = stat.proposedPercentage;
                station.sellout = stat.sellOutPercentage;
                station.cpt = stat.cptPrice;
                station.spot = stat.spotPrice;
                station.defaultCosting = stat.defaultCosting;
            }

            setCampaignBurst((prevState) => {
                return {
                    ...prevState,
                    totalAvailableValue: response.data.totalAvailableValue,
                    totalAvailableImpacts: response.data.totalAvailableImpacts,
                    allocatedBudget: response.data.allocatedBudget,
                    unallocatedBudget: response.data.unallocatedBudget,
                    burstStations: stations,
                    ...(isUserInput && { modified: true })
                };
            });
        } catch (e) {
            console.log('Fail to get campaign split statistics', e);
        }
    };

    const recalcOth = async (stations, isUserInput = true) => {
        if (stations.length === 0) {
            changeMade('campaignStations', [], false);
            return;
        }

        if (!campaign.startDate || !campaign.endDate) {
            alert('Please enter start and end dates');
            return;
        }

        const goal = campaign.campaignGoal.find((g) => g.selected === true);

        // We must check if there is a station that was modified by recalcOth function.
        // If yes, then we have to reset all stations to the default values
        if (stations.findIndex((s) => s.proposed === '-') > -1) {
            stations = stations.map((s) => ({
                id: s.id,
                name: s.name
            }));
        }

        const postObj = {
            startDate: convertToDateString(campaign.startDate),
            endDate: convertToDateString(campaign.endDate),
            dealVersionId: campaign.dealVersionId,
            campaignStations: stations,
            budget: goal?.isBurst ? goal?.burstValue : goal?.value,
            campaignId: campaign.id,
            clientId: campaign.advertiserAccountId
        };

        try {
            const response = await GetCampaignSplitStatistics(postObj);
            const stationStats = response.data.stationStatistics;
            for (const station of stations) {
                const stat = stationStats.find((x) => x.stationId === station.id);
                station.budget = goal.value;
                station.override = '-';
                station.naturalSplit = goal;
                station.proposed = '-';
                station.sellout = '-';
                station.cpt = stat.cptPrice;
                station.spot = stat.spotPrice;
                station.defaultCosting = stat.defaultCosting;
            }

            setCampaign((prevState) => {
                return {
                    ...prevState,
                    campaignStations: stations,
                    ...(isUserInput && { modified: true })
                };
            });
        } catch (e) {
            console.log('Fail to get campaign split statistics', e);
        }
    };

    const recalcBurstOth = async (stations, isUserInput = true) => {
        if (stations.length === 0) {
            updateCampaignBurst('burstStations', []);
            return;
        }

        if (!campaignBurst.startDate || !campaignBurst.endDate) {
            alert('Please enter start and end dates');
            return;
        }

        const goal = campaignBurst.campaignGoal.find((g) => g.selected === true);

        // We must check if there is a station that was modified by recalcOth function.
        // If yes, then we have to reset all stations to the default values
        if (stations.findIndex((s) => s.proposed === '-') > -1) {
            stations = stations.map((s) => ({
                id: s.id,
                name: s.name
            }));
        }

        const postObj = {
            startDate: convertToDateString(campaignBurst.startDate),
            endDate: convertToDateString(campaignBurst.endDate),
            dealVersionId: campaign.dealVersionId,
            campaignStations: stations,
            budget: goal?.isBurst ? goal?.burstValue : goal?.value,
            campaignId: campaignBurst.id,
            clientId: campaign.advertiserAccountId
        };

        try {
            const response = await GetCampaignSplitStatistics(postObj);
            const stationStats = response.data.stationStatistics;
            for (const station of stations) {
                const stat = stationStats.find((x) => x.stationId === station.id);
                station.budget = goal.value;
                station.override = '-';
                station.naturalSplit = goal;
                station.proposed = '-';
                station.sellout = '-';
                station.cpt = stat.cptPrice;
                station.spot = stat.spotPrice;
                station.defaultCosting = stat.defaultCosting;
            }

            setCampaignBurst((prevState) => {
                return {
                    ...prevState,
                    burstStations: stations,
                    ...(isUserInput && { modified: true })
                };
            });
        } catch (e) {
            console.log('Fail to get campaign split statistics', e);
        }
    };

    const setLedgerId = (id) => {
        if (campaign.ledgerId !== id) {
            campaign.campaignStations = [];
        }
        changeMade('ledgerId', id, false);
    };

    const sendValuePotRequest = (effectiveDiscount) => {
        CreateCampaignValuePotRequest(valuePotApprovalWorkflowId, campaign.id, campaign.valuePotSpend)
            .then((result) => {
                if (result.id) {
                    addMessage({
                        message: window.translate('Request submitted successfully'),
                        buttons: [
                            {
                                text: window.translate('Ok')
                            }
                        ]
                    });
                    setActiveValuePotRequest(result);
                }
            })
            .catch((error) => {
                addMessage({
                    message: `${window.translate('Failed to submit request.  Error:')} ${error}`,
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });
            });
    };

    const sendSpotTypeDistributionRequest = () => {
        CreateCampaignSpotTypeDistributionRequest(spotTypeDistributionWorkflowId, campaign.id)
            .then((result) => {
                if (result.id) {
                    addMessage({
                        message: window.translate('Request submitted successfully'),
                        buttons: [
                            {
                                text: window.translate('Ok')
                            }
                        ]
                    });
                    setSpotTypeDistributionRequest(result);
                }
            })
            .catch((error) => {
                addMessage({
                    message: `${window.translate('Failed to submit request.  Error:')} ${error}`,
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });
            });
    };

    const sendRequest = (effectiveDiscount) => {
        CreateCampaignDiscountRequest(
            discountApprovalWorkflowId,
            campaign.id,
            effectiveDiscount,
            (campaign.budget * effectiveDiscount) / 100
        )
            .then((result) => {
                if (result.id) {
                    addMessage({
                        message: window.translate('Request submitted successfully'),
                        buttons: [
                            {
                                text: window.translate('Ok')
                            }
                        ]
                    });
                    setDiscountRequest(result);
                }
            })
            .catch((error) => {
                addMessage({
                    message: `${window.translate('Failed to submit request.  Error:')} ${error}`,
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });
            });
    };

    const sendCancellationRequest = (campaignApprovalTeamId) => {
        CreateCampaignCancellationRequest(
            cancellationApprovalWorkflowId,
            campaign.id,
            businessType === BusinessTypes.AIRTIMEBURST.name ? campaignBurst?.id : undefined,
            campaignApprovalTeamId
        )
            .then((result) => {
                if (result.id) {
                    addMessage({
                        message: window.translate('Request submitted successfully'),
                        buttons: [
                            {
                                text: window.translate('Ok')
                            }
                        ]
                    });
                    setActiveCancellationRequest(result);
                }
            })
            .catch((error) => {
                addMessage({
                    message: `${window.translate('Failed to submit request.  Error:')} ${error}`,
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });
            });
    };

    const handleDiscountRequestApprovalClick = async (effectiveDiscount) => {
        if (!campaign.budget || campaign.budget === 0) {
            addMessage({
                message: window.translate('Please enter a campaign budget'),
                buttons: [
                    {
                        text: window.translate('Ok')
                    }
                ]
            });
            return;
        }

        if (!campaign.modified) {
            sendRequest(effectiveDiscount);
            return;
        }

        addMessage({
            message: window.translate(
                'You have unsaved changes.  These need to be saved before requesting approval. Do you wish to save your changes now?'
            ),
            buttons: [
                {
                    text: window.translate('No'),
                    style: { ...cancelMessageButtonStyle, width: 132 }
                },
                {
                    text: window.translate('Yes'),
                    style: okMessageButtonStyle,
                    callback: async () => {
                        let result;
                        if (campaign.id === window.emptyGuid) {
                            result = await handleCreate();
                        } else {
                            result = await handleUpdate();
                        }
                        if (result) {
                            sendRequest(effectiveDiscount);
                        }
                    }
                }
            ]
        });
    };

    const handleValuePotRequestApprovalClick = async (effectiveDiscount) => {
        if (!campaign.budget || campaign.budget === 0) {
            addMessage({
                message: window.translate('Please enter a campaign budget'),
                buttons: [
                    {
                        text: window.translate('Ok')
                    }
                ]
            });
            return;
        }

        if (!campaign.modified) {
            sendValuePotRequest(campaign.valuePotSpend);
            return;
        }

        addMessage({
            message: window.translate(
                'You have unsaved changes.  These need to be saved before requesting approval. Do you wish to save your changes now?'
            ),
            buttons: [
                {
                    text: window.translate('No'),
                    style: { ...cancelMessageButtonStyle, width: 132 }
                },
                {
                    text: window.translate('Yes'),
                    style: okMessageButtonStyle,
                    callback: async () => {
                        let result;
                        if (campaign.id === window.emptyGuid) {
                            result = await handleCreate();
                        } else {
                            result = await handleUpdate();
                        }
                        if (result) {
                            sendValuePotRequest(campaign.valuePotSpend);
                        }
                    }
                }
            ]
        });
    };

    const handleSpotTypeDistributionRequestClick = async () => {
        if (!campaign.modified) {
            sendSpotTypeDistributionRequest();
            return;
        }

        addMessage({
            message: window.translate(
                'You have unsaved changes.  These need to be saved before requesting approval. Do you wish to save your changes now?'
            ),
            buttons: [
                {
                    text: window.translate('No'),
                    style: { ...cancelMessageButtonStyle, width: 132 }
                },
                {
                    text: window.translate('Yes'),
                    style: okMessageButtonStyle,
                    callback: async () => {
                        let result;
                        if (campaign.id === window.emptyGuid) {
                            result = await handleCreate();
                        } else {
                            result = await handleUpdate();
                        }
                        if (result) {
                            sendSpotTypeDistributionRequest();
                        }
                    }
                }
            ]
        });
    };

    const handleQualifyOutClick = () => {
        addMessage({
            message: window.translate(
                'The campaign will become unusable, but can be copied from the Home Page. Proceed?'
            ),
            buttons: [
                {
                    text: 'No',
                    style: { ...cancelMessageButtonStyle, width: 132 },
                    callback: null
                },
                {
                    text: 'Yes',
                    style: okMessageButtonStyle,
                    callback: () => handleQualifyOutConfirm()
                }
            ]
        });
    };

    const handleQualifyOutBurstClick = () => {
        addMessage({
            message: window.translate('The airtime burst will become unusable. Are you sure you want to proceed?'),
            buttons: [
                {
                    text: 'No',
                    style: { ...cancelMessageButtonStyle, width: 132 },
                    callback: null
                },
                {
                    text: 'Yes',
                    style: okMessageButtonStyle,
                    callback: () => handleQualifyOutBurstConfirm()
                }
            ]
        });
    };

    const handleCancelCampaignConfirm = async () => {
        if (
            campaign?.id &&
            campaign?.id !== window.emptyGuid &&
            (campaign?.campaignStatusName === 'Booked' || campaign?.campaignStatusName === 'Running')
        ) {
            if (campaign?.campaignStatusName === 'Booked' && campaign?.billingTermName === 'Bespoke') {
                const billingPlanInvoices = await GetBillingPlanInvoicesByCampaign(campaign?.id);
                if (billingPlanInvoices?.length) {
                    DeleteBillingPlanInvoicesByCampaign(campaign.id);
                }
            }

            if (cancellationApprovalWorkflowId) {
                // Try to auto-populate the userPAT if this is an EAT workflow
                let isEatWorkflow = 0;
                const dynamicWorkflowTask = UsingDynamicWorkflow([cancellationApprovalWorkflowId]);
                isEatWorkflow = await dynamicWorkflowTask;

                let userPAT = campaign.campaignApprovalTeamId;
                if (isEatWorkflow === 2) {
                    if (!userPAT) {
                        const userTask = GetUser(getClaimValue('ASId'));
                        const userData = await userTask;
                        if (userData?.primaryApprovalTeamId) {
                            userPAT = userData.primaryApprovalTeamId;
                        }
                    }

                    // Show modal asking about approval team if we don't have the userPAT
                    if (!userPAT) {
                        setIsShowingCancelModal(true);
                        return;
                    }
                }

                sendCancellationRequest(userPAT);
                return;
            }

            CancelCampaign(campaign.id).then(() => {
                getCampaign(campaign.id);
            });
        }
    };

    const handleCancelCampaignBurstConfirm = async () => {
        if (
            campaignBurst?.id &&
            campaignBurst?.id !== window.emptyGuid &&
            (campaignBurst?.campaignStatusName === 'Booked' || campaignBurst?.campaignStatusName === 'Running')
        ) {
            // Turn workflow off for now as it has bigger implications
            // if (cancellationApprovalWorkflowId) {
            //     sendCancellationRequest();
            //     return;
            // }

            CancelCampaign(campaign.id, campaignBurst.id).then(() => {
                getCampaignBurst(campaignBurst.id);
            });
        }
    };

    const handleCancelCampaignClick = () => {
        if (campaign?.id && campaign?.id !== window.emptyGuid && campaign?.campaignStatusName === 'Booked') {
            addMessage({
                message: window.translate('Are you sure you want to cancel this Campaign?'),
                buttons: [
                    {
                        text: 'No',
                        style: { ...cancelMessageButtonStyle, width: 132 },
                        callback: null
                    },
                    {
                        text: 'Yes',
                        style: okMessageButtonStyle,
                        callback: () => handleCancelCampaignConfirm()
                    }
                ]
            });
        } else {
            addMessage({
                message: window.translate(
                    'Are you sure that you want to cancel this campaign since all future spots will be removed from the log?'
                ),
                modalStyle: runningCampaignStyle,
                buttons: [
                    {
                        text: 'No',
                        style: { ...cancelMessageButtonStyle, width: 132 },
                        callback: null
                    },
                    {
                        text: 'Yes',
                        style: okMessageButtonStyle,
                        callback: () => handleCancelCampaignConfirm()
                    }
                ]
            });
        }
    };

    const handleCancelCampaignBurstClick = () => {
        if (
            campaignBurst?.id &&
            campaignBurst.id !== window.emptyGuid &&
            campaignBurst.campaignStatusName === 'Booked'
        ) {
            addMessage({
                message: window.translate('Are you sure you want to cancel this airtime burst?'),
                buttons: [
                    {
                        text: 'No',
                        style: { ...cancelMessageButtonStyle, width: 132 },
                        callback: null
                    },
                    {
                        text: 'Yes',
                        style: okMessageButtonStyle,
                        callback: () => handleCancelCampaignBurstConfirm()
                    }
                ]
            });
        } else {
            addMessage({
                message: window.translate(
                    'Are you sure that you want to cancel this airtime burst since all future spots will be removed from the log?'
                ),
                modalStyle: runningCampaignStyle,
                buttons: [
                    {
                        text: 'No',
                        style: { ...cancelMessageButtonStyle, width: 132 },
                        callback: null
                    },
                    {
                        text: 'Yes',
                        style: okMessageButtonStyle,
                        callback: () => handleCancelCampaignBurstConfirm()
                    }
                ]
            });
        }
    };

    const handleAmendCampaignConfirm = async () => {
        if (
            campaign?.id &&
            campaign?.id !== window.emptyGuid &&
            (campaign?.campaignStatusName === 'Booked' || campaign?.campaignStatusName === 'Running')
        ) {
            try {
                await AmendCampaign(campaign.id);
                await getCampaign(campaign.id);
                setReadOnly(false);
                setBookedReadOnly(false);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err?.response?.data ?? err?.message);
                addMessage({
                    message: window.translate('An error occurred while attempting to amend this campaign.'),
                    buttons: [{ text: window.translate('Ok') }]
                });
            }
        }
    };

    const handleAmendCampaignBurstConfirm = async () => {
        if (
            campaignBurst?.id &&
            campaignBurst?.id !== window.emptyGuid &&
            (campaignBurst?.campaignStatusName === 'Booked' || campaignBurst?.campaignStatusName === 'Running')
        ) {
            try {
                await AmendCampaignBurst(campaignBurst.id);
                await getCampaignBurst(campaignBurst.id, true);
            } catch (err) {
                // eslint-disable-next-line no-console
                console.error(err?.response?.data ?? err?.message);
                addMessage({
                    message: window.translate('An error occurred while attempting to amend this campaign burst.'),
                    buttons: [{ text: window.translate('Ok') }]
                });
            }
        }
    };

    const handleDiscardAmendmentCampaignConfirm = async () => {
        if (
            campaign?.id &&
            campaign?.id !== window.emptyGuid &&
            campaign?.campaignStatusName === 'Draft' &&
            campaign?.versionNumber > 0
        ) {
            try {
                await DiscardCampaign(campaign.id);
                await loadPropertyData(campaign?.id);
                await getCampaign(campaign?.id, false);
                setReadOnly(false);
            } catch (err) {
                addMessage({
                    message: window.translate('An error occurred while attempting to discard this campaign amendment.'),
                    buttons: [{ text: window.translate('Ok') }]
                });
            }
        }
    };

    const handleDiscardAmendmentCampaignBurstConfirm = async () => {
        if (
            campaignBurst?.id &&
            campaignBurst?.id !== window.emptyGuid &&
            campaignBurst?.campaignStatusName === 'Draft' &&
            campaignBurst?.versionNumber > 0
        ) {
            try {
                await DiscardCampaignBurst(campaignBurst.id);
                getCampaignBurst(campaignBurst.id);
                setBurstReadOnly(true);
            } catch (err) {
                addMessage({
                    message: window.translate(
                        'An error occurred while attempting to discard this campaign burst amendment.'
                    ),
                    buttons: [{ text: window.translate('Ok') }]
                });
            }
        }
    };

    const handleAmendCampaignClick = () => {
        const isCampaignBurst = !!campaignBurst.id;
        addMessage({
            message: window.translate(
                `Are you sure you want to amend this ${isCampaignBurst ? 'Campaign Burst' : 'Campaign'}?`
            ),
            buttons: [
                {
                    text: 'No',
                    style: { ...cancelMessageButtonStyle, width: 132 },
                    callback: null
                },
                {
                    text: 'Yes',
                    style: okMessageButtonStyle,
                    callback: isCampaignBurst ? handleAmendCampaignBurstConfirm : handleAmendCampaignConfirm
                }
            ]
        });
    };

    const handleDiscardCampaignClick = () => {
        const isCampaignBurst = !!campaignBurst.id;
        addMessage({
            message: window.translate('Are you sure you want to discard this amendment?'),
            buttons: [
                {
                    text: 'No',
                    style: { ...cancelMessageButtonStyle, width: 132 },
                    callback: null
                },
                {
                    text: 'Yes',
                    style: okMessageButtonStyle,
                    callback: isCampaignBurst
                        ? handleDiscardAmendmentCampaignBurstConfirm
                        : handleDiscardAmendmentCampaignConfirm
                }
            ]
        });
    };

    useEffect(() => {
        if (campaign?.campaignStatusName === 'Qualified Out' || campaign?.campaignStatusName === 'Cancelled') {
            setReadOnly(true);
        }
    }, [campaign?.campaignStatusName]);

    useEffect(() => {
        if (campaign?.campaignStatusName === 'Qualified Out' || campaign?.campaignStatusName === 'Cancelled') {
            setReadOnly(true);
        }
    }, [campaign?.campaignStatusName]);

    useEffect(() => {
        if (!readOnly) {
            validateName(campaign.name, false);
        }
    }, [campaign.name]);

    useEffect(() => {
        // Get campaign Lock table details
        if (campaign?.id !== undefined && campaign?.id !== window.emptyGuid) {
            GetCampaignLock(campaign?.id)
                .then((data) => {
                    setCampaignLock(data);
                    actionEdit = true;
                })
                .catch((error) => {
                    console.log(error);
                });
        }
    }, [campaign?.id]);

    useEffect(() => {
        if (!readOnly) {
            validateBurstName(campaignBurst?.name, false);
        }
    }, [campaignBurst?.name]);

    useEffect(() => {
        if (errorValidationCampaignGoal !== '') {
            setValidCampaignGoal(false);
        } else {
            setValidCampaignGoal(true);
        }
    }, [errorValidationCampaignGoal]);

    const updateCampaignLock = (campaign, isReleasedLock) => {
        UpdateCampaignLock(campaign?.id, isReleasedLock).catch((error) => {
            console.log(error);
        });
    };

    const handleCampaignLock = async (campaignLock, campaign) => {
        if (campaign?.id !== undefined && campaign?.id !== window.emptyGuid) {
            if (!Object.keys(campaignLock).length) {
                await GetCampaignLock(campaign?.id).then((data) => {
                    campaignLock = data;
                    setCampaignLock(data);
                });
            }

            if (campaignLock && campaignLock.lockedByDiffUser) {
                setReadOnly(true);
                setBookedReadOnly(true);
                addMessage({
                    message: `${window.translate(
                        `Cannot modify the campaign as it has been locked by ${campaignLock?.userName}`
                    )}`,
                    buttons: [
                        {
                            text: window.translate('Ok')
                        }
                    ]
                });
                actionEdit = false;
                isClickedOnEdit = false;
                return false;
            } else if (campaignLock && !campaignLock.lockedByDiffUser) {
                updateCampaignLock(campaign, false);
                startCampaignLockTimer();
                actionEdit = false;
                return true;
            } else {
                if (campaign?.id !== undefined && campaign?.id !== window.emptyGuid) {
                    startCampaignLock(campaign?.id);
                    actionEdit = false;
                    return true;
                }
            }
        }
    };

    const handleEdit = (editValue) => {
        // Check campaign is locked
        if (!campaignLockSettings?.disableCampaignLocking) {
            let result;
            GetCampaignLock(campaign?.id).then((data) => {
                result = handleCampaignLock(data, campaign);
            });
            if (!result && result !== undefined) {
                return;
            }
        }

        isClickedOnEdit = true;
        if (businessType !== BusinessTypes.AIRTIMEBURST.name) {
            if (campaign?.campaignStatusName === 'Booked' || campaign?.campaignStatusName === 'Running') {
                setBookedReadOnly(editValue);
            } else {
                setCancelledReadOnly(
                    campaign?.campaignStatusName === 'Cancelled' || campaign?.campaignStatusName === 'Completed'
                );
                setReadOnly(editValue);
                if (campaign?.versionNumber > 0) {
                    changeMade('amending', true, editValue);
                    campaign.amending = true;
                }
            }
        } else {
            if (campaignBurst?.campaignStatusName === 'Booked' || campaignBurst?.campaignStatusName === 'Running') {
                setBookedReadOnly(editValue);
            }
            if (
                campaignBurst?.campaignStatusName !== 'Booked' &&
                campaignBurst?.campaignStatusName !== 'Running' &&
                campaignBurst?.campaignStatusName !== 'Expired' &&
                campaignBurst?.campaignStatusName !== 'Completed'
            ) {
                setBurstReadOnly(editValue);
            }
        }
    };

    const handleCancelModalClose = (visible) => {
        setIsShowingCancelModal(visible);
    };

    const handleCancelCampaign = (selectedApprovalTeam) => {
        sendCancellationRequest(selectedApprovalTeam);
        setIsShowingCancelModal(false);
    };

    return (
        <>
            <div style={{ width: '100vw' }}>
                <TopBar
                    title={
                        campaign.id === window.emptyGuid && !campaign.name
                            ? 'New Campaign'
                            : !campaignBurst.name
                            ? campaign.name
                            : `${campaign.name} - ${campaignBurst.name}`
                    }
                    currentStep={currentStep}
                    setCurrentStep={setCurrentStep}
                    handleClose={handleClose}
                    handleUpdateWithMessage={
                        campaignBurst.id && campaignBurst?.id !== window.emptyGuid
                            ? () => handleUpdateCampaignBurst(true, false)
                            : handleUpdateWithMessage
                    }
                    handleQualifyOutClick={
                        businessType !== BusinessTypes.AIRTIMEBURST.name
                            ? handleQualifyOutClick
                            : handleQualifyOutBurstClick
                    }
                    handleCancelCampaignClick={
                        businessType !== BusinessTypes.AIRTIMEBURST.name
                            ? handleCancelCampaignClick
                            : handleCancelCampaignBurstClick
                    }
                    handleAmendCampaignClick={handleAmendCampaignClick}
                    handleDiscardCampaignClick={handleDiscardCampaignClick}
                    activeCancellationRequest={activeCancellationRequest}
                    campaign={campaign}
                    createCampaign={campaignBurst?.id ? () => handleCreateCampaignBurst(false) : handleCreate}
                    journeyBarLoader={journeyBarLoader}
                    setJourneyBarLoader={setJourneyBarLoader}
                    readOnly={businessType !== BusinessTypes.AIRTIMEBURST.name ? readOnly : burstReadOnly}
                    bookedReadOnly={bookedReadOnly}
                    onEdit={handleEdit}
                    // showEditButton={isEditable && campaign?.campaignStatusName !== 'Cancelled'}
                    showEditButton={isEditable}
                    pageBackSource={pageBackSource}
                    campaignVersions={
                        campaignBurst.id // && campaignBurst?.id !== window.emptyGuid
                            ? campaignBurstVersions
                            : campaignVersions
                    }
                    currentCampaignVersionId={
                        campaignBurst.id && campaignBurst?.id !== window.emptyGuid
                            ? currentBurstVersionId
                            : currentCampaignVersionId
                    }
                    setCurrentCampaignVersionId={
                        campaignBurst.id && campaignBurst?.id !== window.emptyGuid
                            ? setCurrentBurstVersionId
                            : setCurrentCampaignVersionId
                    }
                    validCampaignName={validCampaignName}
                    validBurstName={validBurstName}
                    validCampaignGoal={validCampaignGoal}
                    validCategory={validCategory}
                    validDeal={validDeal}
                    validDates={!errorValidationDates}
                    campaignBurst={campaignBurst}
                    externalIsBooked={externalIsBooked}
                    isBurst={isBurst}
                    campaignSaving={campaignSaving}
                    disableBackButton={disableBackButton}
                />
                {
                    /* This is all really horrible but it is what it is , back and front end enums are a muddle and the journeybar is a nightmare. Rewrite pronto */
                    currentStep === 0 &&
                        (businessType !== BusinessTypes.AIRTIMEBURST.name ? (
                            <CampaignBrief
                                campaign={campaign}
                                propertyTotals={propertyTotals}
                                setPropertyTotals={setPropertyTotals}
                                recalcTotals={recalcTotals}
                                changeMade={changeMade}
                                staticData={staticData}
                                readOnly={readOnly || isCampaignCompleted || cancelledReadOnly}
                                bookedReadOnly={bookedReadOnly}
                                setReadOnly={setReadOnly}
                                IsValidCampaignName={setValidCampaignName}
                                IsValidCampaignGoal={setValidCampaignGoal}
                                IsValidDeal={setValidDeal}
                                IsValidCategory={setValidCategory}
                                ValidationInputCampaignGoal={validCampaignGoal}
                                ValidationInputCategory={validCategory}
                                setValidJcn={setValidJcn}
                                validJcn={validJcn}
                                setValidValuePotJcn={setValidValuePotJcn}
                                validValuePotJcn={validValuePotJcn}
                                errorValidationCategory={errorValidationCategory}
                                errorValidationProperty={errorValidationProperty}
                                errorValidationCampaignGoal={errorValidationCampaignGoal}
                                setErrorValidationCampaignGoal={setErrorValidationCampaignGoal}
                                setErrorValidationCategory={setErrorValidationCategory}
                                errorValidationAccount={errorValidationAccount}
                                setErrorValidationAccount={setErrorValidationAccount}
                                errorValidationDates={errorValidationDates}
                                setErrorValidationDates={setErrorValidationDates}
                                validationInput={validationInput}
                                setValidationInput={setValidationInput}
                                activeRequest={activeRequest}
                                setActiveRequest={setActiveRequest}
                                activeValuePotRequest={activeValuePotRequest}
                                discountApprovalWorkflowId={discountApprovalWorkflowId}
                                valuePotApprovalWorkflowId={valuePotApprovalWorkflowId}
                                onValuePotRequestApprovalClick={handleValuePotRequestApprovalClick}
                                onDiscountRequestApprovalClick={handleDiscountRequestApprovalClick}
                                setBillingAccountId={setBillingAccountId}
                                setCampaignStartDate={setCampaignStartDate}
                                setCampaignEndDate={setCampaignEndDate}
                                readOnlyProperty={readOnlyProperty}
                                setReadOnlyProperty={setReadOnlyProperty}
                                businessType={businessType ?? campaign?.businessType}
                                campaignNameStatus={campaignNameStatus}
                                setCampaignNameStatus={setCampaignNameStatus}
                                propertySelectionId={propertySelectionId}
                                returnPropsAvailable={returnPropsAvailable}
                                propertySaved={propertySaved}
                                propertyTypes={propertyTypes}
                                onDelete={loadPropertyData}
                                currentDeal={currentDeal}
                                setCurrentDeal={setCurrentDeal}
                                setSelectedGoal={setSelectedGoal}
                                selectedGoal={selectedGoal}
                                contactRoles={contactRoles}
                                setContactRoles={setContactRoles}
                                revenueTypes={revenueTypes}
                                setRevenueTypes={setRevenueTypes}
                                campaignStages={campaignStages}
                                setCampaignStages={setCampaignStages}
                                forecastCategories={forecastCategories}
                                setForecastCategories={setForecastCategories}
                                discountChanged={discountChanged}
                                setDiscountChanged={setDiscountChanged}
                                discountRequest={discountRequest}
                                dealDiscounts={dealDiscounts}
                                setDealDiscounts={setDealDiscounts}
                                setDiscountRequest={setDiscountRequest}
                                recalculateOffAirs={recalculateOffAirs}
                                dealStationPrices={dealStationPrices}
                                formatLaydown={formatLaydown}
                                currentCampaignVersionId={currentCampaignVersionId}
                                isEditClick={isClickedOnEdit}
                                campaignVersions={campaignVersions}
                            />
                        ) : (
                            <CampaignBurstBrief
                                parentCampaign={campaign}
                                loadParentCampaign={getCampaign}
                                campaignBurst={campaignBurst}
                                changeMade={changeMade}
                                setValidJcn={setValidJcn}
                                validJcn={validJcn}
                                createCampaignBurst={() => handleCreateCampaignBurst(false)}
                                updateCampaignBurst={() => handleUpdateCampaignBurst(true, false)}
                                updateCampaignBurstObject={updateCampaignBurst}
                                errorValidationCampaignBurstGoal={errorValidationCampaignGoal}
                                setErrorValidationCampaignBurstGoal={setErrorValidationCampaignGoal}
                                readOnly={burstReadOnly || isCampaignCompleted || cancelledReadOnly}
                                setReadOnly={setBurstReadOnly}
                                campaignBurstNameStatus={campaignBurstNameStatus}
                                setCampaignBurstNameStatus={setCampaignBurstNameStatus}
                                staticData={staticData}
                                IsValidBurstName={setValidBurstName}
                                validationInputCampaignGoal={validCampaignGoal}
                            />
                        ))
                }
                {displayStep(campaign?.businessType, currentStep, 'StationSelection') && (
                    <>
                        <CampaignStations
                            campaign={campaign}
                            campaignBurst={
                                campaignBurst.id && campaignBurst.id !== window.emptyGuid ? campaignBurst : undefined
                            }
                            changeMade={
                                campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                    ? updateCampaignBurst
                                    : changeMade
                            }
                            staticData={staticData}
                            recalc={campaignBurst.id && campaignBurst.id !== window.emptyGuid ? recalcBurst : recalc}
                            recalcOth={
                                campaignBurst.id && campaignBurst.id !== window.emptyGuid ? recalcBurstOth : recalcOth
                            }
                            readOnly={
                                campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                    ? burstReadOnly || isCampaignCompleted || cancelledReadOnly
                                    : readOnly || isCampaignCompleted || cancelledReadOnly
                            }
                            ledgers={ledgers}
                            setLedgerId={setLedgerId}
                            isBurst={isBurst}
                        />
                    </>
                )}
                {displayStep(campaign?.businessType, currentStep, 'AutomationSettings') && (
                    <AutomationSettings
                        campaign={campaignBurst.id && campaignBurst.id !== window.emptyGuid ? campaignBurst : campaign}
                        changeMade={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? handleAutomationSettingsBurstChange
                                : handleAutomationSettingsChange
                        }
                        onRationaleChange={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? undefined
                                : handleRationaleChange
                        }
                        onSpotTypeDistributionApprovalClick={handleSpotTypeDistributionRequestClick}
                        spotTypeDistributionWorkflowId={spotTypeDistributionWorkflowId}
                        activeRequest={spotTypeDistributionRequest}
                        staticData={staticData}
                        networks={networks}
                        readOnly={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? burstReadOnly || isCampaignCompleted || cancelledReadOnly
                                : readOnly || isCampaignCompleted || cancelledReadOnly
                        }
                    />
                )}
                {displayStep(campaign?.businessType, currentStep, 'AirtimePlanning') && (
                    <AirtimePlanning
                        campaign={campaign}
                        campaignVersionId={campaignBurst.id ? currentBurstVersionId : currentCampaignVersionId}
                        recalc={campaignBurst.id && campaignBurst.id !== window.emptyGuid ? recalcBurst : recalc}
                        changeMade={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid ? updateCampaignBurst : changeMade
                        }
                        readOnly={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? burstReadOnly || isCampaignCompleted || cancelledReadOnly
                                : readOnly || isCampaignCompleted || cancelledReadOnly
                        }
                        campaignBurst={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid ? campaignBurst : undefined
                        }
                        isBurst={isBurst}
                    />
                )}
                {displayStep(campaign?.businessType, currentStep, 'PropertySelection') && (
                    <PropertySelection
                        campaign={campaign}
                        getCampaign={getCampaign}
                        readOnly={readOnly || isCampaignCompleted || cancelledReadOnly}
                    />
                )}
                {displayStep(campaign?.businessType, currentStep, 'PackageSelection') && (
                    <PackageSelection
                        campaign={campaign}
                        getCampaign={getCampaign}
                        readOnly={readOnly || isCampaignCompleted || cancelledReadOnly}
                    />
                )}
                {displayStep(campaign?.businessType, currentStep, 'OffAirCosts') && (
                    <OffAirCosts
                        campaign={campaign}
                        changeMade={changeMade}
                        readOnly={readOnly || cancelledReadOnly}
                        billingAccountId={billingAccountId}
                        campaignStartDate={campaignStartDate}
                        campaignEndDate={campaignEndDate}
                        recalculateOffAirs={recalculateOffAirs}
                        revenueTypes={revenueTypes}
                    />
                )}
                {displayStep(campaign?.businessType, currentStep, 'BespokeBilling') &&
                    campaign?.billingTermName === 'Bespoke' && (
                        <BespokeBilling
                            campaign={campaign}
                            pendingBespokeInvoices={pendingBespokeInvoices}
                            setPendingBespokeInvoices={setPendingBespokeInvoices}
                            changeMade={changeMade}
                            readOnly={
                                campaign?.campaignStatusName === 'Draft' ||
                                campaign?.campaignStatusName === 'Cancelled' ||
                                campaign?.campaignStatusName === 'Completed'
                                    ? readOnly
                                    : bookedReadOnly
                            }
                            currentDeal={currentDeal}
                            selectedGoal={selectedGoal}
                            currentCampaignVersionId={currentCampaignVersionId}
                        />
                    )}
                {displayStep(
                    campaign?.businessType,

                    campaign?.billingTermName === 'Bespoke' ? currentStep - 1 : currentStep,
                    'QuoteBooking'
                ) && (
                    <QuoteAndBooking
                        readOnly={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? burstReadOnly || cancelledReadOnly
                                : readOnly || cancelledReadOnly
                        }
                        campaign={campaign}
                        billingAccountCreditDetails={billingAccountCreditDetails}
                        changeMade={changeMade}
                        getCampaign={getCampaign}
                        getCampaignBurst={getCampaignBurst}
                        updateCampaign={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? () => handleUpdateCampaignBurst(false, false)
                                : handleUpdate
                        }
                        campaignBurst={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid ? campaignBurst : undefined
                        }
                        activeRequest={activeRequest}
                        discountRequest={discountRequest}
                        dealDiscounts={dealDiscounts}
                        onDiscountRequestApproval={handleDiscountRequestApprovalClick}
                        discountApprovalWorkflowId={discountApprovalWorkflowId}
                        valuePotRequest={activeValuePotRequest}
                        valuePotApprovalWorkflowId={valuePotApprovalWorkflowId}
                        isBurst={isBurst}
                    />
                )}
                {displayStep(
                    campaign?.businessType,
                    campaign?.billingTermName === 'Bespoke' ? currentStep - 1 : currentStep,
                    'AirtimeSettings'
                ) && (
                    <AirtimeSettings
                        campaign={campaign}
                        UpdateCampaign={UpdateCampaign}
                        changeMade={changeMade}
                        staticData={staticData}
                        networks={networks}
                        readOnly={bookedReadOnly || isCampaignCompleted || cancelledReadOnly}
                    />
                )}
                {displayStep(
                    campaign?.businessType,

                    campaign?.billingTermName === 'Bespoke' ? currentStep - 1 : currentStep,
                    'TransmissionTimes'
                ) && (
                    <TransmissionTimes
                        campaign={campaign}
                        campaignBurst={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid ? campaignBurst : undefined
                        }
                        campaignVersionId={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? currentBurstVersionId
                                : currentCampaignVersionId
                        }
                        readOnly={campaignBurst.id && campaignBurst.id !== window.emptyGuid ? burstReadOnly : readOnly}
                        campaignStartDate={campaignStartDate}
                        campaignEndDate={campaignEndDate}
                        currentCampaignName={currentCampaignName}
                    />
                )}
                {displayStep(
                    campaign?.businessType,
                    campaign?.billingTermName === 'Bespoke' ? currentStep - 1 : currentStep,
                    'Billing'
                ) && (
                    <Billing
                        campaign={campaign}
                        changeMade={changeMade}
                        staticData={staticData}
                        readOnly={readOnly && bookedReadOnly}
                        contactRoles={contactRoles}
                    />
                )}
                {displayStep(
                    campaign?.businessType,
                    campaign?.billingTermName === 'Bespoke' ? currentStep - 1 : currentStep,
                    'Performance'
                ) && (
                    <Performance
                        campaign={campaign}
                        staticData={staticData}
                        readOnly={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? burstReadOnly || cancelledReadOnly
                                : readOnly || cancelledReadOnly
                        }
                    />
                )}
                {!(businessType === BusinessTypes.AIRTIMEBURST.name && currentStep === 0) && (
                    <ReferenceAndSavePanel
                        campaign={businessType !== BusinessTypes.AIRTIMEBURST.name ? campaign : campaignBurst}
                        createCampaign={
                            campaignBurst.id && campaignBurst.id !== window.emptyGuid
                                ? () => handleCreateCampaignBurst(false)
                                : handleCreate
                        }
                        updateCampaign={changeMade}
                        currentStep={currentStep}
                        readOnly={
                            campaignBurst.id && campaignBurst?.id !== window.emptyGuid
                                ? burstReadOnly || cancelledReadOnly
                                : readOnly || cancelledReadOnly
                        }
                        bookedReadOnly={bookedReadOnly}
                        validCampaignName={validCampaignName}
                        validCampaignGoal={validCampaignGoal}
                        validCategory={validCategory}
                        validDeal={validDeal}
                        validDates={!errorValidationDates}
                        handleUpdateWithMessage={
                            campaignBurst.id && campaignBurst?.id !== window.emptyGuid
                                ? () => handleUpdateCampaignBurst(true, false)
                                : handleUpdateWithMessage
                        }
                        campaignSaving={campaignSaving}
                    />
                )}
            </div>
            <CancelCampaignModal
                isShowing={isShowingCancelModal}
                workflowTeams={workflowTeams}
                onClose={handleCancelModalClose}
                onDoCancel={handleCancelCampaign}
            />
        </>
    );
};

export default CampaignPage;
